Em.I18n.locales ||= {}
module.exports = Em.I18n.locales['ru'] =
  status_mini_popup:
    confirm_sms_hint: 'отправить СМС-уведомление клиенту о подтверждении заказа'
    cancel_sms_hint:  'отправить СМС-уведомление клиенту об отмене заказа'

  draft_dish:
    weight_units:
      gram: 'грамм'
      kilogram: 'килограмм'
      hundred_gram: '100 грамм'
      milliliter: 'миллилитр'
      liter: 'литр'
      hundred_milliliter: '100 миллилитров'
    weight_units_short:
      gram: 'г'
      kilogram: 'кг'
      hundred_gram: '100 гр'
      liter: 'л'
      milliliter: 'мл'
      hundred_milliliter: '100 мл'
    excise_units:
      commodity: 'Товар'
      excise: 'Подакцизный товар'
      service: 'Услуга'
      excise_with_label: 'Подакцизный товар без кода маркировки'
      excise_without_label: 'Подакцизный товар с кодом маркировки'
      commodity_with_label: 'Неподакцизный товар с кодом маркировки'
      commodity_without_label: 'Неподакцизный товар без кода маркировки'
      other: 'Другое'
  loyalty:
    notifier:
      title: 'Программа лояльности {{text}}'
      status:
        new: 'создана'
        old: 'сохранена'
    confirm:
      delete: 'Удалить программу лояльности?'
      cancel: 'Отменить изменения?'
  client_tag_info:
    notifier:
      title: 'Тег {{text}}'
      status:
        new: 'создан'
        old: 'сохранен'
    confirm:
      delete: 'Удалить тег?'
      cancel: 'Отменить изменения?'
  bonus_category_info:
    notifier:
      title: 'Категория {{text}}'
      status:
        new: 'создана'
        old: 'сохранена'
    confirm:
      delete: 'Удалить бонусную категорию?'
      cancel: 'Отменить изменения?'
  banner:
    notifier:
      title: 'Баннер {{text}}'
      status:
        new: 'создан'
        old: 'сохранен'
    confirm:
      delete: 'Удалить баннер?'
      cancel: 'Отменить изменения?'
      save: 'Необходимо сохранить баннер перед загрузкой фотографии. Сохранить?'
  advert:
    notifier:
      title: 'Объявление {{text}}'
      status:
        new: 'создано'
        old: 'сохранено'

    filter:
      restaurants:
        zero_data: 'У клиента должен быть хотя бы один заказ из выбранных ресторанов.'
        content: 'Выбраны рестораны: {{restaurants}}'

    confirm:
      delete: 'Удалить объявление?'
      cancel: 'Отменить изменения?'
      save: 'Необходимо сохранить объявление перед загрузкой фотографии. Сохранить?'
      execute: 'Подтвердите запуск рассылки. Будет затронуто {{clients}}'
      cancel: 'Отменить запланированную рассылку?'

    status:
      draft:      'черновик'
      scheduled:  'запущена'
      processing: 'идет рассылка'
      paused:     'рассылка приостановлена'
      canceled:   'рассылка отменена'
      complete:   'рассылка завершена'

    result:
      error:'Ошибка'
      success: 'Успешно'

    transport:
      sms: 'SMS'
      email: 'E-mail'
      client_push_then_sms: 'Push, а потом SMS'
      client_push: 'Push'
      communication_channels: 'Каналы коммуникации'

  sip:
    status:
      online:         'онлайн'
      offline:        'оффлайн'
      error:          'ошибка'
      connecting:     'соединение'
      disconnecting:  'отключение'

    error:
      init_failed:         'Неверный формат учетной записи SIP.'
      connection_failed:   'Не удалось подключиться к SIP-прокси серверу.'
      registration_failed: 'Регистрация не пройдена. Проверьте правильность введенных данных для подключения.'

  c:
    client_tags:
      notification:
        title: 'Выполнено'
        message: 'Теги для клиентов обновлены'
      buttons:
        start_editing: 'редактировать теги'
        finish_editing: 'закончить редактирование'
        group_editing: 'групповое редактирование'
        group_add: 'Добавить теги всем клиентам'
        group_delete: "Удалить теги у всех клиентов"
        reset_filters: "Сбросить фильтры"
      confirms:
        accept_reset_filters: 'Фильтры будут сброшены до первоначального состояния, продолжить?'
    client_table:
      last_order_date: 'последний заказ был {{date}}'
      average_check: 'средний чек'
    account_photo:
      upload: 'Загрузить фото'

    add_tag_button:
      add_button: 'Добавить'
      add_text: 'Добавить «{{q}}»'
      placeholder:
        search: 'Поиск по тегам'

    banner_photo:
      intro: 'Перетяните фото или нажмите загрузить'
      no_photo: 'Фотография не загружена'
      drop_photo: 'Отпустите фотографию для загрузки'
      upload: 'Загрузить'

    advert_photo:
      intro: 'Перетяните фото или нажмите загрузить'
      no_photo: 'Фотография не загружена'
      drop_photo: 'Отпустите фотографию для загрузки'
      upload: 'Загрузить'

    billing_operation_table_row:
      invoice: 'списание произойдет {{date}}'
      invoice_with_act: 'Услуги оказаны {{date}}'
      invoice_date: 'Счет сформирован {{date}}'
      download_act: 'Загрузить бухгалтерский акт'
      download_invoice: 'Загрузить cчет для оплаты'
      currency: 'руб.'

    carrier_item:
      available_in: 'Доступен в городах:'
      rating:
        speed: 'скорость'
        price: 'цена'
        quality: 'качество'
      connected: 'Подключен'
      carrier_sent: 'Заявка<br>отправлена'
      carrier_sent_hover: 'Отправить<br>заявку повторно'
      connect: 'Подключить'

    client_card:
      no_name: 'Клиент без имени'
      address: 'Адреса клиента'
      blacklisted: 'Клиент из чёрного списка'
      client_comment: 'комментарий к клиенту'
      bonuses:
        none: 'У клиента нет бонусов'
        one: 'У клиента {{count}} бонусный балл на счете'
        few: 'У клиента {{count}} бонусных балла на счете'
        many: 'У клиента {{count}} бонусных баллов на счете'
      save: 'Сохранить'
      add_comment: 'добавить комментарий к клиенту'

    client_order_block:
      order_contents: 'Состав заказа'
      item_amount: 'шт.'
      process: 'Обработать'
      unprocess: 'Отменить обработку'
      process_error: 'Невозможно изменить статус обработки заказа'

    clients_table_row:
      is_blacklisted: 'Клиент из чёрного списка'
      last_order_date: 'последний заказ был {{date}}'

  pages:
    table:
      content:
        name: 'Название'
        slug: 'Адрес'
        position: 'Позиция'
        show_in_app: 'Отображается в приложении'
        show_in_web: 'Отображается на сайте'
        page_type: 'Тип страницы'
      types:
        html: 'HTML'
        collection: 'Коллекция'
      filters:
        visibility: 'Видимость'


  error_page:
    header: 'Ошибка загрузки данных'
    comment: 'Такое обычно происходит при попытке открытия заказа или другой информации, где данные сейчас недоступны.'
    back_button: 'Вернуться на главную'

  themes:
    title: 'Выбор темы'
    back_button: 'Назад'
    publish_button: 'Опубликовать'
    change_theme: 'Изменить тему'
    common_settings: 'Общие настройки'
    theme_settings: 'Параметры темы'
    not_configurable: 'Данная тема не имеет конфигурируемых параметров'
    reset_button: 'Сбросить настройки'

    confirms:
      reset: 'Сброс настроек удалит все пользовательские настройки. Продолжить?'


    notifications:
      publish:
        title: 'Опубликовано'
        message: '{{theme}} опубликована на сайте ресторана'
      reset:
        title: 'Успешно'
        message: 'Настройки {{theme}} успешно сброшены'

  client_edit:
    header:
      title: 'Клиент #'
      first_order: 'Первый заказ:'
      order_history: 'История заказов'
      activity: 'Активность клиента'
      tabs:
        history: 'История заказов'
        bonuses: 'Бонусы'
        communications: 'Коммуникации'

    form:
      card_track:
        label: 'Бонусная карта'
        placeholder: 'Номер бонусной карты'
      avatar:
        label: 'Фотография'
      name:
        label: 'Имя'
        placeholder: 'Имя'
      phone:
        label: 'Телефон'
        placeholder: 'Телефон'
        call: 'позвонить'
      email:
        label: 'E-mail'
        placeholder: 'E-mail'
      bonuses:
        label: 'Бонусы'
        placeholder: 'Введите количество бонусов'
        add: 'Начислить'
        substract: 'Списать'
        confirm_transaction: 'Изменить баланс?'
        amount:
          none: 'У клиента нет бонусов'
          one: 'У клиента {{count}} бонусный балл на счете'
          few: 'У клиента {{count}} бонусных балла на счете'
          many: 'У клиента {{count}} бонусных баллов на счете'
        count:
          none:   ''
          one:    'бонус'
          few:    'бонуса'
          many:   'бонусов'
          other:  'бонусов'
      issue:
        label: 'Выдать код'
      birthday:
        label: 'День рождения'
      tags:
        label: 'Теги'
      recurrence:
        label: 'Возвращаемость'
      comment:
        label: 'Комментарий'
        placeholder: 'Комментарий'
      black_list:
        label: 'Черный список'
        control: 'Добавить в чёрный список'
        caption: 'Заказы данного клиента будут помечены особым образом'
        comment: 'Причина добавления в черный список'
        listed_by: 'Кто и когда отправил в черный список'
    history:
      header: 'История заказов'
      new_order: 'Новый заказ'
      change_balance: 'Изменить баланс'
      cancel_balance_change: 'Отменить'
      all: 'Все'
      not_processed: 'Необработанные'
      processed: 'Обработанные'
      orders_to_show: 'Отображение заказов'
    buttons:
      save: 'Сохранить'
      delete: 'Удалить'
      close: 'Закрыть'

  story_frame_edit:
    header:
      left: 'Изображениe кадра'
      right: 'Параметры кадра'
    button_text: 'Текст для кнопки'
    button_url:  'Ссылка для кнопки'
    photo_help: 'Перетяните изображение или нажмите загрузить'
    no_photo: 'Изображение кадра не загружено'
    drop_photo: 'Отпустите изображение для загрузки'
    save_banner_for_edit: 'Необходимо сохранить баннер перед внесением изменений. Сохранить?'
    title: 'Заголовок'
    description: 'Описание'
    disclaimer: 'Дисклеймер'
    background_color: 'Цвет фона'
    content_text_color: 'Цвет текста'
    button_variant:
      title: 'Вариант отображения кнопки'
      primary: 'Основной'
      secondary: 'Дополнительный'
    content_style:
      title: 'Вариант отображения контента'
      default: 'Стандартный'
      additional: 'Дополнительный'
      centered: 'Центрированный'
    frame_variant:
      title: 'Вариант отображения кадра'
      image: 'Изображение'
      text: 'Заливка фона'



  dish_edit:
    photo:
      tabs:
        main: 'Основное фото'
        additional: 'Дополнительные фото'
    photo_help: 'Перетяните фото или нажмите загрузить'
    no_photo: 'Фотография блюда не загружена<br>
              Загрузите фото, чтобы оно отображалось на сайте'
    drop_photo: 'Отпустите фотографию для загрузки'
    buttons:
      upload: 'Загрузить'
    availability:
      title: 'Доступность блюд в ресторане'
      enabled_timetable: 'Для блюда определено расписание доступности.'
      edit_timetable: 'Редактировать расписание'
      about_timetable: 'Расписание доступности позволяет автоматизировать постановку и снятие стопов с блюд.'
      about_availability: 'Здесь вы можете скрыть блюдо из меню  ресторанов, либо отметить, что наличие блюда требует уточнения по телефону'
      no_available: 'Временно недоступно'
      need_call: 'Уточнить по телефону'
      loading: 'Загружается'
    configurator:
      new_configurator_title: 'Новый конфигуратор #{{ordinal}}'
      placeholders:
        item_name: 'название'
        item_price: 'Цена'
      buttons:
        add_new_group:
          dish_group: 'Добавить комбо'
          modifier_group: 'Добавить группу модификаторов'
        delete_configuration: 'Удалить конфигурацию'
        configuration_settings: 'Настроить конфигурацию'
        add_new_configuration: 'Добавить конфигурацию'
        remove_group: 'Удалить группу'
        remove_group_parent: 'По умолчанию'
      parent: 'Зависит от модификатора'
      labels:
        base_price: 'Базовая цена'
        allow_additional_comment: 'Разрешить примечания'
      allow_additional_comment_caption: 'Позволяет гостям добавлять примечания к блюду при заказе'
      configuration_settings: 'Настроить конфигурацию'
      config_types:
        label: 'Тип конфигурации'
        modifier_group: 'Группа модификаторов'
        dish_group: 'Комбо'
      type:
        modifier_group: 'Настройка группы модификаторов'
        dish_group: 'Настройка комбо'
      add_new: 'Добавить позицию'
      base_price_caption: 'Используется для начала расчета общей цены сконфигурированного блюда'
      groups_zero_data: 'Пока не добавлено ни одной группы конфигураторов'
      multiple_select:
        title: 'Можно выбрать несколько вариантов'
        min: 'Не менее чем'
        max: 'и не более, чем'
        about: 'вариантов'
      zero_data:
        title: 'Нет созданных конфигураций'
        caption: 'Добавьте конфигурацию, чтобы дать клиенту возможность выбора параметров блюда. Примером конфигурации может быть выбор соуса, добавки или размера порции'

    header:
      edit: 'Редактирование блюда'
      readonly: 'Параметры блюда'
      tabs:
        configurator: 'Конфигуратор'
        prices: 'Цены'
        advanced: 'Дополнительно'
      configurator:
        edit: 'Конфигуратор'
        readonly: 'Конфигуратор (только просмотр)'
    form:
      ingridients: 'Состав'
      calories: 'Калории'
      proteins: 'Белки'
      fats: 'Жиры'
      carbs: 'Углеводы'
      title:
        app: 'Cайт и приложение'
        description: 'Описание'
        integrations: 'Интеграции'
        promos: 'Акции и бонусы'
        additional: 'Дополнительно'
      slug:
        label: 'Адрес (slug)'
        placeholder: 'Адрес (slug)'
      name:
        label: 'Название блюда'
        placeholder: 'Название блюда'
      price:
        label: 'Цена'
        placeholder: 'Цена'
      weight_price:
        label: 'Цена за {{unit}}'
        placeholder: 'Цена за {{unit}}'
      weight:
        label: 'Вес'
        placeholder: 'Вес'
      price_weight_unit:
        label: 'Единицы измерения для расчета цены'
        placeholder: ''
      weight_unit:
        label: 'Единицы измерения'
        placeholder: ''
      excise_unit:
        label: 'Признак акциза'
        placeholder: ''
      external_id:
        label: 'Внешний код (id)'
        placeholder: 'id'
        caption: 'используется при интеграции виджета Смартомато'
      description:
        label: 'Описание блюда'
        placeholder: 'Описание'
      category:
        label: 'Категория'
      suggesting:
        label:
          on: 'Приоритет для рекомендации'
          off: 'Советовать это блюдо?'
        priority: 'Приоритет'
        disable: 'отключить'
        caption: 'Можно задать большое количество блюд для доп. продаж, тогда приоритеты позволят Смартомато выбирать наиболее подходящие для рекомендации.'
        enable: 'Включить блюдо в доп. продажи'
      disabled_sources:
        label: 'Запрет на выгрузку в агрегаторы'
        caption: 'Можно запретить продажу блюда для определенного агрегатора либо нескольких агрегаторов'
      extras:
        label: 'Дополнительно'
        is_list: 'Показывать в текстовом виде'
        can_zoom: 'Можно увеличить картинку'
        is_hidden: 'Исключить из меню'
        is_stealthy: 'Не отображать в меню'
        is_bonus_only: 'Блюдо только за бонусы'
        no_bonus_accrue: 'Не начислять бонусы за это блюдо'
        dont_discount: 'Не давать на это блюдо скидку'
        unaccounted_for_promo: 'Не учитывать при расчете суммы заказа для применения акций'
        prohibit_takeaway: 'Запретить блюдо в самовывозе'
        prohibit_delivery: 'Запретить блюдо в доставке'
        prohibit_dine_in:  'Запретить блюдо в заказе к столу'
        is_popular: 'Выводить в блок популярных блюд'
        restrict_bonus_withdrawal: 'Запретить списывать бонусы на это блюдо'
        is_required: 'Обязательное блюдо'
      is_next_day:
        label: 'Доставка на следующий день'
        toggle: 'Блюдо с доставкой на следующий день'
        hour_count: 'Кол-во часов с начала следующих суток'
        caption: 'По-умолчанию заказы с таким блюдом будут переноситься на начало следующих суток и дальше брать время из зон доставки.<br><br>\
              Но если доставка работает после полуночи, такие блюда перенесутся на 00:01.<br><br> \
              Количество часов позволит перенести время на указанное количество часов вперед. <br><br>\
              Вы можете задать время глобально для всей организации (для этого напишите нам в чат) или индивидуально для каждого блюда.'
      is_metric:
        label: 'Весовое блюдо'
        toggle: 'Блюдо с указанием веса'
      min_qty:
        weight: 'Минимальный вес ({{unit}})'
        volume: 'Минимальный объем ({{unit}})'
      delta_qty:
        weight: 'Шаг изменения веса ({{unit}})'
        volume: 'Шаг изменения объема ({{unit}})'
      old_price:
        label: 'Старая цена'
        placeholder: 'старая цена'
        caption: 'Эта цена будет выводиться на сайте перечеркнутой'
      cooking:
        time:
          label: 'Время приготовления'
          placeholder: 'Время'
          caption: 'Время приготовления блюда в минутах для расчета графика готовки.<br>Оставьте пустым, если необходимо использовать время приготовления из зоны доставки'
          unit: 'мин'
        line:
          label: 'Цех'
          caption: 'Производственная линия, в рамках которой будет готовиться блюдо'
      tags:
        label: 'Бейджи'
        placeholder: 'Вегетарианское, Низкокалорийное, Острое'
        caption: 'Можно указать слова через запятую, каждое такое слово станет бейджем на сайте'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'
    prices:
      price:
        label: 'Цена'
        is_hidden: 'нет в меню'
        is_default: 'сейчас цены и наличие по-умолчанию'
        override: 'переопределить'
      base_price:
        label: 'Базовая цена конфигуратора'
      disable: 'отключить разные цены'
      zero_data:
        header: 'Цены и наличие в разных ресторанах'
        caption: 'Сейчас блюдо включено в меню всех ресторанов по одинаковой цене'
        enable: 'Задать разные цены или наличие'

    buttons:
      save: 'Сохранить'
      delete: 'Удалить'
      cancel: 'Отменить'

  category_edit:
    new: 'Новая категория'
    header:
      edit: 'Редактирование категории'
      readonly: 'Параметры категории'
    form:
      disclaimer: '＊ Поддерживается только в части тем оформления'
      name:
        label: 'Название категории'
        placeholder: 'Название категории'
      external_id:
        label: 'Внешний код (id)'
        placeholder: 'id'
        caption: 'используется при интеграции с ресторанными системами учета'
      description:
        label: 'Описание'
        placeholder: 'Описание'
      parent:
        label: 'Родительская категория'
      export_hidden:
        label: 'Экспортировать скрытые в агрегаторы'
      disabled_sources:
        label: 'Запрет на выгрузку в агрегаторы'
        caption: 'Можно запретить выгрузку категории для определенного агрегатора либо нескольких агрегаторов'
      extras:
        label: 'Дополнительно'
        is_list: 'Отображать содержимое в виде текста (только в части тем оформления)'
        is_hidden: 'Скрыть в меню'
        toggle_hidden_recursively: 'Скрыть/показать в ресторане все блюда'
        age_restriction: '18+'
        toggle_hidden_restaurant_id: 'Выберите ресторан'
        toggle_hidden:
          true: 'Скрыть'
          false: 'Показать'
      meta_title:
        label: 'Meta title'
        placeholder: 'meta title'
      meta_description:
        label: 'Meta description'
        placeholder: 'meta description'

    buttons:
      save: 'Сохранить'
      delete: 'Удалить'
      cancel: 'Отменить'

  reports:
    sidebar:
      report_type: 'Тип отчета'
      add_filter: 'Добавить фильтр'
      condition_and: 'условие или'
      condition_or: 'условие и'
      remove_filter: 'Удалить фильтр'
      choose: 'выберите'
      group_by: 'Группировать по'
      execute_button: 'Исполнить'
    content:
      loading: 'Формирование отчета...'
      zero_data:
        header: 'Конструктор отчетов'
        caption: 'Выберите необходимый тип отчета, задайте условия при помощи фильтров и нажмите «Исполнить»'

  orders:
    sidebar:
      filters:
        reset: 'Сбросить'
        apply: 'Применить'
        status: 'Статус: '
        restaurant: 'Ресторан: '
        zone: 'Зона: '
        courier: 'Курьер: '
        date: 'Дата доставки: '
        zeroData: 'Фильтры не заданы'
        elepsis:  'и другие фильтры'
      now: 'Сейчас'
      later: 'Позже'
      all: 'Все'
      placeholders:
        search: 'Умный поиск'
      sections:
        organization: 'Организация'
        is_bk: 'Исключить еду для курьеров'
        status: 'Статус заказа'
        date_range: 'Период доставки'
        separator: 'до'
        client_rate: 'Оценка клиента'
        restaurants: 'Рестораны'
        deliveryZones: 'Зоны доставки'
        assigned_couriers: 'Назначенные курьеры'
        order_sources: 'Источник заказа'
        delivery_types: 'Способ получения'
        payment_sources: 'Способы оплаты'
        payment_status: 'Статус оплаты онлайн'
        archive_orders: 'Выводить заказы старше двух недель'
        orders_count: 'Показано заказов {{ordersLength}} / {{ordersCount}}'
        orders_count_title: 'Отображается {{orders}} из {{total}} заказов'
        orders_sum_title: 'Общая сумма заказов'
      buttons:
        show_limit_orders: 'Показать все заказы'
        search_query: 'Ожидаем окончания ввода...'
    table:
      no_number: 'нет номера'
      no_text: 'не указано'
      assign_courier: 'назначить'
      order_change: 'сдача с'
      content:
        number: "#"
        status: 'Статус'
        published_at: 'Поступил'
        restaraunt: 'Ресторан'
        client: 'Клиент'
        address: 'Адрес'
        client_rate: 'Оценка'
        tag: 'Категория'
        pos_status: 'POS статус'
        delivery_at: 'Доставить'
        delivery_at_range: '{{day}} с {{from}} по {{to}}'
        courier: 'Курьер'
        confirmed_by: 'Оператор'
        payment_source: 'Оплата'
        final_sum: 'Сумма заказа'
        delivery_price: 'Стоимость доставки'
        source: 'Источник'
        delivery_zone: 'Зона'
        loading: 'Загружаем заказы'
        zero_data:
          archive_not_found: 'Нет заказов'
          archive_limited: 'Выборка ограничена последними двумя неделями'
          archive_limited_caption: 'Для доступа к архивным заказам включите переключатель "Выводить заказы старше двух недель" в панели фильтров'
          no_archive: 'Нет заказов'
          no_archive_caption: 'По указанным критериям нет ни одного заказа'
  courier_apps:
    header: 'Самое время установить приложение курьера!'
    comment_start: 'Похоже, что вы авторизовались как курьер Смартомато. Вы будете видеть заказы, назначенные на вас, в разделе '
    orders_button: 'Заказы'
    comment_end: ', но не сможете подтверждать их и управлять доставкой.'
    setup_application: 'Чтобы управлять своими заказами, установите приложение курьера для Android или перейдите в онлайн-интерфейс управления заказами, адаптированный для планшетов.'
    button_ios_app: 'Приложение для iOS'
    button_android_app: 'Приложение для Android'
    button_mobile_app: 'Веб-интерфейс для планшетов'
    goto_orders: 'Перейти в раздел Заказы'

  clients:
    client_card:
      registered: 'Зарегистрирован {{when}}'
      lastorder: 'Последний заказ {{when}}'
      birthdate: 'Дата рождения {{when}}'
      card: 'Карта лояльности: №{{number}}'

    clients_count:
      one:    'клиент'
      few:    'клиента'
      many:   'клиентов'
      other:  'клиентов'

    bonuses_count:
      one:    'бонус'
      few:    'бонуса'
      many:   'бонусов'
      other:  'бонусов'

    filter:
      smart_search: 'Умный поиск'
      tags: 'Теги'
      no_tags_message: 'У вас пока нет тегов, добавьте их на карточке клиента и определите его категорию.'
      dishes: 'Заказанные блюда'
      recurrence: 'Возвращаемость'
      order_status: 'Статус заказа'
      delivery_type: 'Способ получения'
      sources: 'Источники'
      organizations: 'Организации'
      cities_restaurants: 'Города (по ресторанам)'
      unrestricted: 'Без ограничений'
      restaurants: 'Рестораны'
      order_period: 'Период заказов'
      average_check: 'Средний чек'
      orders_count: 'Количество заказов'
      black_list: 'Чёрный список'
      from: 'от'
      to: 'до'
      communications:
        label: 'Коммуникации'
        unprocessed_orders: 'Необработанные отзывы'
        unread_messages: 'Непрочитанные сообщения'

    index:
      sort_by: 'Сортировать:'
      found: 'Найдено'
      recurrence_change_dynamics: 'динамика изменения возвращаемости'
      percent: 'в процентах'
      absolute: 'абсолютно'
      loading: 'Загружаем клиентов'
      nothing_found: 'Клиенты не найдены'
      nothing_found_comment: 'Попробуйте изменить параметры фильтрации'

    client_type:
      'new':
        one: 'новый'
        few: 'новых'
        many: 'новых'
        other: 'новых'
      active:
        one: 'активный'
        few: 'активных'
        many: 'активных'
        other: 'активных'
      returned:
        one: 'вернувшийся'
        few: 'вернувшихся'
        many: 'вернувшихся'
        other: 'вернувшихся'
      cold:
        one: 'остывший'
        few: 'остывших'
        many: 'остывших'
        other: 'остывших'
      dead:
        one: 'потерянный'
        few: 'потерянных'
        many: 'потерянных'
        other: 'потерянных'

    recurrence_filter:
      'new'       : 'Новые'
      active    : 'Активные'
      returned  : 'Вернувшиеся'
      cold      : 'Остывшиe'
      dead      : 'Потерянные'

    recurrence_label:
      'new'       : 'Новый'
      active    : 'Активный'
      returned  : 'Вернувшийся'
      cold      : 'Остывший'
      dead      : 'Потерянный'

    recurrence_label_long:
      'new'       : 'Новый клиент'
      active    : 'Активный клиент'
      returned  : 'Вернувшийся клиент'
      cold      : 'Остывший клиент'
      dead      : 'Потерянный клиент'

    recurrence_comment:
      'new'       : 'Клиент сделал первый заказ'
      active    : 'Клиент регулярно заказывает на протяжении более 2 недель'
      returned  : 'Клиент снова стал заказывать'
      cold      : 'Клиент не заказывал уже больше 2 недель'
      dead      : 'Клиент не заказывал уже больше 1 месяца'

    order_source:
      delivery_club :     'Delivery Club'
      foodfox       :     'Яндекс.Еда'
      obed_ru       :     'Obed.ru'
      broniboy      :     'Broniboy'
      chibbis       :     'Chibbis'
      glovo         :     'Glovo'
      vk            :     'Vk'
      sbermarket    :     'Sbermarket'
      wolt          :     'Wolt'
      yandex_lavka  :     'Яндекс.Лавка'

      external_site        : 'Внешний сайт'
      external_site_mobile : 'Внешний сайт (мобильная версия)'
      marketplace          : 'Витрина'
      marketplace_mobile   : 'Витрина (мобильная версия)'
      board                : 'Board'

      mobile_application_ios: 'Приложение iOS'
      mobile_application_android: 'Приложение Android'
      iiko:               'iiko'
      external_aggregator: 'Внешний агрегатор'

    orders:
      one:    'заказ'
      few:    'заказа'
      many:   'заказов'
      other:  'заказов'

    # sort:
    #   orders_count_asc   : 'увеличению числа заказов'
    #   orders_count_desc  : 'уменьшению числа заказов'
    #   average_check_asc  : 'увеличению среднего чека'
    #   average_check_desc : 'уменьшению среднего чека'
    #   created_at_asc     : 'увеличению даты регистрации'
    #   created_at_desc    : 'уменьшению даты регистрации'

    sort:
      orders_count   : 'по числу заказов'
      average_check  : 'по среднему чеку'
      created_at     : 'по дате регистрации'
      bonus_count    : 'по балансу бонусов'

  date:
    today:     'сегодня'
    tomorrow:  'завтра'
    yesterday: 'вчера'
    by: 'к'
    at: 'в'
    during: 'в течение'
    during_days:
      one:    '{{count}} день'
      few:    '{{count}} дня'
      many:   '{{count}} дней'
      other:  '{{count}} дней'

    during_hours:
      one:    '{{count}} часа'
      few:    '{{count}} часов'
      many:   '{{count}} часов'
      other:  '{{count}} часов'

    during_minutes:
      one:    '{{count}} минты'
      few:    '{{count}} минут'
      many:   '{{count}} минут'
      other:  '{{count}} минут'

    during_seconds:
      one:    '{{count}} секунды'
      few:    '{{count}} секунд'
      many:   '{{count}} секунд'
      other:  '{{count}} секунд'
    week_days: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],


  billing:
    form:
      settings:
        title: 'Пополнение счёта',
        caption: 'После подтверждения вы будете перенаправленны на окно оплаты'
        labels:
          sum: 'Сумма'
        buttons:
          pay: 'Оплатить'
          cancel: 'Отменить'
      header: 'Настройки тарифного плана'
      set_payment_method: 'Выберите способ оплаты'
      update_requisites: 'Обновить реквизиты'
      enable_pay_by_card: 'Включить оплату картой'
      enable_pay_by_bank: 'Включить оплату через расчетный счет'
      empty_subheader: 'Тарифный план влияет на ограничения, связанные с использованием сервиса'
      current_tariff: ' Ваш текущий тариф «{{tariff}}»'
      unit: 'руб./мес.'
      change_tariff: 'Изменить тариф'
      payment_method: 'Способ оплаты подписки'
      change_payment_method: 'Изменить способ оплаты или реквизиты'
      state:
        normal:
          header: 'Все оплачено'
          comment: 'Следующее списание {{date}}'

        free:
          header: 'Бесплатный тариф'

        invoices:
          header: 'К оплате {{sum}} руб.'
          comment: 'Необходимо оплатить до {{date}}'

        dept:
          header: 'К оплате {{sum}} руб.'
          comment: 'Сервис будет доступен до {{date}}'

        blocked:
          header: 'Организация заблокирована'
          comment: 'Блокировка была произведена {{date}}'

        paywall:
          header: 'Тестовый период'
          comment: 'До {{date}} действует ознакомительный период. Выберите тарифный план до его завершения.'

        paywall_deadline:
          header: 'Тестовый период истек'
          comment: 'Ознакомительный период завершен. Выберите тарифный план для продолжения работы.'
      choose_tariff: 'Выбрать тарифный план'
      choose_tariff_and_setup_payment: 'Выбрать тарифный план и настроить способ оплаты'
      pay_button_dept: 'Пополнить счёт'
      pay_button: 'Оплатить'
      operations:
        header: 'История операций по счету'
        table:
          date: 'Дата'
          operation: 'Операция'
          sum: 'Сумма'
      balance:
        label: 'На вашем счете'
        currency: 'руб.'

    payment_method:
      tab_card:
        header: 'Для оплаты картой никаких особых настроек не требуется'
        content: 'Раз в месяц нужно будет переходить по ссылке на оплату, которую мы будем присылать и оплачивать очередную сумму.'

      header: 'Настройка способа оплаты Смартомато'
      comment: 'Вы можете оплачивать подписку через расчетный счет или банковской картой'
      tabs:
        card: 'Банковская карта'
        bank_account: 'Расчетный счет'
      bank_details:
        header: 'Реквизиты организации:'

        payer_name:
          label: 'Название юридического лица'
          placeholder: 'ООО "Лос Поллос Херманос"'
        inn:
          label: 'ИНН'
          placeholder: ''
        kpp:
          label: 'КПП'
          placeholder: ''
        address:
          label: 'Юридический адрес'
          placeholder: 'Нужен для выставления счетов'
        settlement_account:
          label: 'Расчетный счет'
          placeholder: ''
        corresponding_account:
          label: 'Корр.счет'
          placeholder: ''
        bik:
          label: 'БИК'
          placeholder: ''
        bank_name:
          label: 'Название Банка'
          placeholder: ''
        signer:
          label: 'Подписант, ФИО'
          placeholder: 'Иванов И.И.'
        role:
          label: 'Подписант, должность'
          placeholder: 'Генеральный директор'

        act_subheader: 'Данные для формирования акта оказанных услуг'




    tariffs:
      header: 'Выберите наиболее подходящий вам тарифный план'
      subheader: 'Вы можете изменить тарифный план в любое время'

      change_tariff:
        plain:   'Перейти на тариф «{{tariff_name}}»'
        paywall: 'Начать использование на тарифном плане'
        paywall_before_deadline: 'Начать использование сервиса на тарифном плане'

    warnings:
      trial_period:     'В данный момент действует ознакомительный период. Выберите тарифный план до {{deadline}}.'
      paywall_warning:  '{{deadline}} заканчивается ознакомительный период. Выберите тарифный план во избежание блокировки.'
      paywall_expired:  'Ознакомительный период завершен. Выберите тарифный план для продолжения работы.'

      free_tariff:      'Вы находитесь на бесплатном тарифе, прием заказов на сайте не работает'
      blocked:          'Организация заблокирована из-за неоплаты, прием заказов на сайте не работает'
      rush_mode_restaurants: '🔥 В части ресторанов включен режим высокого спроса: {{disabled}} из {{total}}'
      blocked_restaurants: '🔒 Часть ресторанов заблокирована для приема заказов: {{disabled}} из {{total}}'
      dept_detected:    'У вас сформировалась задолженность, оплатите {{sum}} до {{deadline}} во избежание блокировки'
      pending_invoices: 'До {{deadline}} необходимо оплатить {{sum}} за использование сервиса «Смартомато»'
    notifications:
      change_tariff_error: 'Ошибка'


  order:
    contact_call_allowed: 'Необходим звонок 📞'
    contact_call_not_allowed: 'Не звонить ⚠️'
    promos:
      promo_card:
        is_free: 'в подарок'
        available_till: 'действует до'
        dish_choice: 'Блюдо на выбор'
        order_discount: 'Скидка на заказ'
        before_discount: 'Скидка '
        after_discount: '% на заказ'
        after_discount_fixed: 'на заказ'
        button_later: 'Не использовать'
        button_now: 'Использовать сейчас'
        cancel_promo_code: 'Отменить промо-код'

    organization_select_text: 'Выберите организацию'
    status_mini_popup:
      client_notification_type_call: 'Необходим звонок клиенту'
      annotation: 'Управляйте текущим ходом выполнения заказа'
      cancel_reason: 'Укажите причину отмены'
      placeholders:
        cancel_reason_comment: 'Укажите причину отмены'
      buttons:
        change_status: 'Изменить статус'
        open_history: 'Посмотреть историю изменений'
    map_popup:
      warning:
        order_unpaid: '⚠️ ЗАКАЗ ЕЩЕ НЕ ОПЛАЧЕН'
        order_expired: '⚠️ ЗАКАЗ ПРОСРОЧЕН'
      order_name: '№{{order}}'
      takeaway: 'самовывоз'
      delivery_price: 'доставка {{currency}}'
      delivery_free: 'бесплатная доставка'
      payment_source: '{{paymentSource}}'
      choose_self_courier: 'Выбрать курьера'
      time:
        cooking_start: 'Начать готовить'
        cooking_start: 'Начать готовить'
        pick_up_at: 'Забрать заказ'
        delivery_at: 'Доставить заказ'
        shelf_time: 'Годность заказа до'
      outsource:
        outsource_courier: 'Назначен курьер'
        no_delivery_request: 'Заявка на доставку еще не размещена'
        outsource_courier_pickup_time: 'Курьер будет:'
        outsource_delivery_price: 'Цена аутсорса доставки:'
        outsource_messages: 'Сообщения'
      buttons:
        confirm: 'Подтвердить заказ'
        dispose: 'Списать заказ'
      client_notification_type_call: 'Необходим звонок клиенту'
    courier_mini_popup:
      external_delivery: 'Заказ находится на аутсорсе в {{externalDelivery}} '
      selected_courier:
        courier_free: 'Курьер свободен'
        distance: 'Расстояние до ресторана'
        order_number: 'Заказ №{{order}}'
        no_address: 'без адреса'
        picked_up_at: 'Забрал в'
        pick_up_at: 'Забор (план)'
        delivery_at: 'Доставка к'
      annotation:
        choose_self: 'Выберите курьера, который будет доставлять заказ'
        non_created_outsource: 'Заявка на аутсорс доставки в {{externalDelivery}} не создана'
        confirm_create_outsource: 'Подтвердите размещение заявки в {{externalDelivery}}'
        cancel_courier_assign: 'Нажмите второй раз на строку с курьером, чтобы снять его назначение'
        external_courier: 'Если вы продолжите, аутсорс в {{externalDelivery}} будет отменен.'
        self_courier: 'Вы сможете разместить заказ на своего курьера.'
        cancel_self_before_place: 'Для передачи заказа на аутсорс в {{externalDelivery}} — снимите её с собственного курьера'
        error: 'Ошибка'
      buttons:
        back: 'назад'
        cancel_outsource_delivery: 'Подтвердить отмену аутсорса'
        cancel: 'Отмена'
        place_outsource: 'Разместить заявку'

    time_mini_popup:
      annotation: 'Укажите временные интервалы обработки заказа'
      section:
        cooking_start_at: 'Начать готовить'
        pick_up_at: 'Забрать заказ'
        delivery_at: 'Доставить заказ'
      buttons:
        save: 'Сохранить'
      takeaway: 'самовывоз'
      order_name: 'Заказ #{{order}}'
      payment_source: '{{paymentSource}}'
      time:
        cooking_start:'Начать готовить'
        delivery_at: 'Доставить заказ'
      buttons:
        confirm: 'Подтвердить заказ'
    feasibility_warnings:

      transportation_time: 'Заказ могут не успеть ДОВЕЗТИ. Нужно было {{transportation_time}} мин., а у вас выходит {{trans_time}} мин.'
      cooking_time:        'Заказ могут не успеть ПРИГОТОВИТЬ. Нужно было {{cooking_time}} мин., а у вас выходит {{cook_time}} мин.'

    problems:
      is_past_delivery_end_deadline:       'Заказ не был вовремя доставлен'
      is_past_delivery_start_deadline:     'Заказ не был вовремя передан курьеру'
      is_past_cooking_end_deadline:        'Заказ не был вовремя приготовлен'
      is_past_cooking_start_deadline:      'Приготовление не началось вовремя'
      is_past_confirm_deadline:            'Заказ не был подтвержден вовремя'
      is_past_payment_deadline:            'Заказ все еще не оплачен'
      is_past_courier_deadline:            'Курьер не назначен вовремя'
      is_past_restaurant_confirm_deadline: 'Ресторан не подтвердил заказ'

    payment_method:
      cash: 'наличными'
      card: 'картой онлайн'
      courier_card: 'картой курьеру'
      delivery_club_card_online: 'на сайте DeliveryClub'
      external_service_card_online: 'онлайн на внешнем сервисе'
      extra_bonuses: ' + бонусы'

    pos_status:
      pending: 'Ожидает отправки'
      error: 'Ошибка отправки'
      success: 'Успешно отправлен'

    payment_status:
      paid: 'оплачен'
      unpaid: 'не оплачен'

    delivery_type:
      takeaway: 'самовывоз'
      dine_in: 'заказ к столику'
      delivery:  'доставка курьером'

    asap_type:
      specified_time: 'к определенному времени'
      asap: 'как можно скорее'

    status:
      draft:     'Черновик'
      pending:   'Новый'
      confirm:   'Подтвержден'
      preparing: 'Готовится'
      prepared:  'Приготовлен'
      delivery:  'У курьера'
      complete:  'Доставлен'
      undo:      'Отменен'

    scheduled: 'Назначен на {{when}}'
    takeaway: 'Самовывоз'
    dine_in: 'Заказ к столику'

    bonus_card:
      title: 'Бонусы и скидки'
      discount: 'Скидка на заказ'
      bonus_dish: 'Выберите блюдо:'

    content:
      edit:
        item_free: 'в подарок'

    summary:
      items_sum: 'заказ'
      delivery_price: 'доставка'
      used_bonuses: 'бонусные баллы'
      discount_sum: 'скидка'
      commission_sum: 'комиссия'
      service_charge_amount: 'сервисный сбор'
    edit:
      do_time_update: 'Cкорректировать остальное время?'
      configurator:
        comment: 'Комментарий'
        labels:
          total_price: 'Итого'
        placeholders:
          comment: 'Дополнительные пожелания'
      order_now_viewing: 'Заказ сейчас просматривают: '
      draft_status_notice: 'Вы не можете управлять статусом чернового заказа. Используйте кнопку «разместить» для перевода заказа в статус «новый»'
      normal_header: 'Заказ #{{number}}'
      draft_header: 'Черновой заказ'
      order_content_header: 'Состав заказа'
      published_at: 'размещен {{when}}'
      reset_change: 'сдача не нужна?'
      address_warning: 'Номер дома не был точно определен'

      pos_error:
        label: '⚠️ Ошибка отправки в POS'
        retry_export_disabled: '⛔ Достигнут лимит переотправки заказа'

      client_search: 'Поиск клиента...'
      new_client: 'Этого клиента еще нет в вашей базе'

      edit_order:     'редактировать'
      finish_editing: 'закончить'
      delete_confirm: 'Вы действительно хотите удалить заказ?'

      payment:
        warning: '⚠️ Заказ еще не оплачен.'
        success: '✅ Заказ оплачен'

      sync:
        synced: 'Заказ сохранен в {{when}}'
        syncing: 'Сохранение...'
        error: 'Ошибка сохранения!'

      history:
        empty_history: 'истории изменений нет'
        loading_text: 'Загрузка истории...'

      delivery_zone:
        minimal_order_price: 'Минимальный заказ:'
        delivery_time: 'Время доставки: '
        free_delivery_price: 'Бесплатно с:'
        time_unit: ' мин.'
        delivery_price: 'Цена доставки:'
      labels:
        status: 'Статус'
        restaurant: 'Ресторан'
        comment: 'Комментарий'
        change: 'Нужна сдача с'
        use_bonuses: 'Оплатить бонусами'
        payment: 'Оплата'
        qr_payment_status: 'Статус оплаты через QR'
        takeaway: 'Пункт самовывоза'
        when_delivery: 'Доставить'
        when_pickup: 'Передать заказ'
        client_delivery_at: 'Когда передать клиенту'
        cooking_start_at: 'Когда начать готовить'
        table: 'Столик'
        delivery_at: 'Когда доставить'
        pick_up_at: 'Когда забрать из ресторана'
        client:
          phone: 'Телефон'
          name: 'Имя'
          rate: 'Оценка клиентом'
        delivery_type: 'Способ получения'
        city: 'Город'
        delivery_address: 'Адрес доставки'
        delivery_zone: 'Зона доставки'
        delivery_price: 'Цена доставки'
        use_promo_code: 'Указать промокод'
        used_promo_code: 'Использован промокод'
        courier: 'Курьер'
        use_delivery: 'Доставить'
        tag: 'Категория'
        pos_status: 'POS статус'
        staff_comment: 'Комментарий сотрудника'
        cutlery: 'Количество приборов'
      buttons:
        add_dish: 'Добавить блюдо'
        close: 'Закрыть'
        place: 'Разместить'
        more_details: 'показать больше деталей'
        only_statuses: 'показать только статусы'
        retry_export: 'Переотправить'

      placeholders:
        address: 'Адрес'
        apartment: 'квартира'
        floor: 'этаж'
        staircase: 'подъезд'
        address_comment: 'комментарий к адресу'
        buddy_name: 'Укажите имя'
      hints:
        geocode_order: 'Определить зону доставки'
      dish_selection:
        title: 'Выберите блюдо'
        nothing_found: 'Ничего не найдено'
        is_hidden: 'Скрыто в меню'
        buttons:
          back: 'Назад'
        placeholders:
          search: 'Поиск блюда'
      bonus_amount:
        none: ''
        one: 'Доступно для использования: {{count}} бонусный бал'
        few: 'Доступно для использования: {{count}} бонусных балла'
        many: 'Доступно для использования: {{count}} бонусных баллов'

  monitor:
    notifications:
      common_title:                'Заказ #{{number}} — {{name}}'
      new_order_title:             'Поступил новый заказ #{{number}}'
      paid:                        'Заказ #{{number}} оплачен'
      confirm_deadline:            'Заказ пришел {{when}}, но все еще не был подтвержден'
      cooking_start_deadline:      'Заказ должен был начать готовиться {{when}}, но все еще в статусе «{{status}}»'
      cooking_end_deadline:        'Заказ должен был быть приготовлен {{when}}, но все еще в статусе «{{status}}»'
      delivery_start_deadline:     'Заказ должен был быть у курьера {{when}}, но все еще в статусе «{{status}}»'
      delivery_end_deadline:       'Заказ должен был быть доставлен {{when}}, но все еще в статусе «{{status}}»'
      payment_deadline:            'Заказ еще не был оплачен'
      courier_deadline:            'Забор заказа из ресторана {{when}}, а курьер еще не был назначен'
      status_changed:              'Заказ перешел в статус «{{status}}»'
      courier_confirmed:           'Курьер {{courier_name}} подтвердил заказ'
      restaurant_confirmed:        'Получено подтверждение заказа рестораном {{restaurant_name}}'
      just_created:                'Подтвердите заказ {{when}}'
      restaurant_confirm_deadline: 'Заказ все еще не был подтвержден рестораном'
      cooking_start:               'Начать приготовление. Забор заказа из ресторана {{when}}'

      active_order:            'Отложенный заказ вернулся в работу, доставка {{when}}'
      delayed_order:           'Заказ перешел в категорию «отложенный»'

  # ---
  # Конфигуратор
  # ---
  configurator:
    confirm:
      remove_group_binding: 'Удалить привязку группы?'
      remove_modifier_scheme: 'Удалить конфигуратор у блюда?'
    validations:
      single_select:      '{{groupName}}: необходимо выбрать ровно один вариант'
      multiple_select:    '{{groupName}}: необходимо выбрать от {{min}} до {{max}} вариантов'

  currency: '{{price}} руб.'
  dashboard:
    sidebar:
      done_title: 'Подготовить сайт ресторана к запуску'
      done_caption: 'Отлично! Ваш сайт готов к запуску. Скоро мы расскажем вам, как поднять продажи и повысить эффективность.'
      header:  'Подготовьте сайт ресторана к запуску'
      progress: 'Выполнено {{done}}/{{total}}'
    main:
      restaurant_multiselect: 'Отображать данные по всем доступным ресторанам'
      zero:
        title: 'Статистика ресторана'
        text: 'Пока что у нас недостаточно информации для отображения реальной динамики продаж, пиковых нагрузок и частотной карты заказов'
        disclaimer: 'Демонстрационные данные'
      range:
        week: 'Неделя'
        month: 'Месяц'
        year: 'Год'
    dynamics:
      orders_summary:
        one:    'заказ'
        few:    'заказа'
        many:   'заказов'
        other:  'заказов'
      revenue: 'общая выручка'
      average_check: 'средний чек'
      header: 'Динамика заказов'
      pie_chart_caption: 'Структура клиентов по возвращаемости'
      bar_chart:
        header: 'Пиковые нагрузки в течение суток'
        work_days: 'Будни'
        weekends: 'Выходные'
        whole_week: 'Вся неделя'
      baskets:
        map_header: 'Карта заказов'
        dishes_header: 'Популярные блюда'
        loading: 'Загрузка данных...'
        dish_unit: 'шт.'




  sm_select:
    placeholder:
      zero:   'Ничего не выбрано'
      one:    'Выбран {{count}} элемент'
      few:    'Выбрано {{count}} элемента'
      many:   'Выбрано {{count}} элементов'
      other:  'Выбрано {{count}} элементов'

  staff:
    roles:
      admin:          'Администратор'
      regional_admin: 'Региональный администратор (франчайзи)'
      manager:        'Менеджер'
      manager_logist: 'Менеджер-логист'
      logist:         'Логист'
    notifications:
      order_created:              'Новый заказ'
      order_restaurant_confirmed: 'Принятие заказа рестораном'
      order_courier_confirmed:    'Подтверждение заказа курьером'
      order_cooking_start:        'Приход заказа на кухню'
      billing_event:              'Оплата услуг Смартомато'
      negative_rate_received:     'Получение негативной оценки по заказу'
      restaurant_running_changed: 'Включение или отключение ресторана'
      pos_order_export_error:     'Получение ошибки отправки заказа на кассу'
      client_message_created:     'Входящее сообщение от клиента'
      communication_channel_updated: 'Обновление статуса канала'

  staff_table:
    is_me: 'Это вы'
    in_restaurant: 'в ресторане'

  checklist:
    theme_selected:      'Выберите дизайн сайта'
    menu_filled:         'Добавьте несколько блюд'
    has_delivery_zones:  'Задайте зону и условия доставки'
    has_couriers:        'Подключите курьеров'
    has_address_phone:   'Укажите телефон и адрес ресторана'
    has_domain:          'Выберите домен'
    is_published:        'Опубликуйте сайт'



  menu:
    channels: 'Каналы'
    static_pages: 'Страницы'
    sandbox: 'UI'
    organizations:  'Организации'
    analytics:      'Веб-аналитика и SEO'
    restaurants:    'Рестораны'
    couriers:       'Курьеры'
    delivery:       'Доставка'
    dishes:         'Меню'
    themes:         'Сайт'
    mobile_app:     'Приложение'
    orders:         'Заказы'
    billing:        'Тарифный план'
    profile:        'Настройки профиля'
    staff:          'Сотрудники'
    business_role:  'Бизнес роли'
    sip:            'Телефония'
    yandex_business:            'Яндекс Бизнес'
    support:        'Помощь'
    clients:        'Клиенты'
    promos:         'Акции'
    map:            'Карта'
    organization_settings: 'Настройки организации'
    organization_settings_header: 'Настройки'
    payment_methods: 'Способы оплаты заказа'
    integrations:   'Интеграции'
    integrations_settings:   'Настройки интеграций'
    logout: 'Выйти'
    utilities: 'Дополнительно'
    interface: 'Настройки интерфейса'
    reports: 'Отчеты'
    promo_constructor: 'Промоакции'
    loyalty_programs: 'Программы лояльности'
    bonus_categories: 'Бонусные категории'
    ads_and_push: 'Реклама и рассылки'
    banners: 'Баннеры'
    client_tags: 'Теги'

  login:
    please_authorize: 'Пожалуйста, авторизуйтесь'
    login_placeholder: 'Логин'
    password_placeholder: 'Пароль'
    sign_in: 'Войти'
    cant_login: 'Не удалось войти!'
    label_restore_password: 'Введите адрес электронной почты, на которую мы отправим письмо с инструкцией по сбросу пароля'
    mail: 'Почта'
    send_password: 'Отправить пароль'
    cancel: 'Отмена'
    login: 'Логин'
    password: 'Пароль'
    password_restore_was_send: 'Письмо с инструкцией по сбросу пароля отправлено на вашу электронную почту'
    captcha_error: 'Ошибка! Подтвердите, что вы не робот.'
    sign_up_link: 'Зарегистрируйтесь,'
    sign_up_link_comment: 'если у вас нет учетной записи'
    restore_button: 'Забыли пароль?'

  notifications:
    organization_saved:
      title: 'Сохранено'
      message: 'Организация успешно сохранена.'

    restaurant_saved:
      title: 'Сохранено'
      message: 'Ресторан успешно сохранен.'

    restaurant_error:
      title: 'Ошибка'
      message_fallback: 'При сохранении ресторана произошла ошибка'

    restaurant_destroy_error:
      title: 'Удаление невозможно'
      message_fallback: 'Проверьте, что данный ресторан не содержит зон доставки и заказов'

  categories:
    published_at: 'Последняя публикация {{date}} в {{time}}'
    not_published: 'Меню еще не было опубликовано'
    publish: 'Опубликовать меню'
    add_category: 'Добавить категорию'
    edit_placeholder: 'Введите имя'
    upload_photo: 'Загрузить фото'
    delete_category: 'Удалить категорию'
    add_dish: 'Добавить блюдо'
    zero_data:
      header: 'Категория не выбрана'
      caption: 'Выберите категорию, чтобы посмотреть подробную информацию или начать редактирование.'
    editConfigurator: 'Настройки конфигураторов'
    search: 'Поиск'

    confirm:
      save_before_photo: 'Необходимо сохранить категорию перед загрузкой фотографии. Сохранить?'
      delete: 'Удалить категорию? Все блюда из категории будут удалены.'

    new_configurator:
      categories: 'Категории'
      modifiers: 'Модификаторы'
      combo: 'Комбо'
      help: 'Модификаторы – характеристики блюд, которые добавляют к ним определенное свойство или особенность приготовления (например, «без соли», «с лимоном» и тд.).
            <br>
            <br>
            Модификаторы удобно использовать, как конструктор бизнес ланча, бургера или лапши в коробочке'

  dish_groups:
    title: 'Настройка комбо'
    new_group: 'Новое комбо'
    dish_group:
      header: 'Список блюд'
      comment: 'Укажите список возможных блюд'
    zero_data:
      title: 'Нет созданных комбо'
      caption: 'Добавьте комбо, чтобы дать клиенту возможность собрать уникальную комбинацию блюд. Примером комбо может быть бизнес ланч'
    buttons:
      add: 'Добавить'
      edit: 'Редактировать'
    help: 'Комбо – это удобный способ собрать набор блюд, которые идеально дополняют друг друга. Например, вы можете составить бизнес-ланч, выбрав любимые суп, салат и горячее, или заказать сет из 5 пицц с разнообразными вкусами для компании.
          <br>
          <br>
          Комбо позволяют создавать индивидуальные решения, которые подойдут под любой вкус и ситуацию.'

  modifier_groups:
    zero_data:
      title: 'Нет созданных конфигураций'
      caption: 'Добавьте конфигурацию, чтобы дать клиенту возможность выбора параметров блюда. Примером конфигурации может быть выбор соуса, добавки или размера порции'
    buttons:
      add: 'Добавить'
      edit: 'Редактировать'

    condition:
      minmax: 'Требование к количеству'
      view_type: 'Отображать как'
      prompt: 'Побудительная форма'

    title: 'Настройка модификаторов'


  delivery:
    menu:
      couriers: 'Курьеры'
      zones: 'Зоны доставки'
      own_couriers: 'Свои курьеры'

    outsource:
      statuses:
        canceled: 'Отменен'
        idle: 'Нет заявки'
        claim_created: 'Поиск курьера'
        courier_assigned: 'Курьер назначен'
        delivering: 'Идет доставка'
        delivered: 'Доставлен'
        problem: 'Проблема'
        pickup_arrived: 'Курьер прибыл'

    zone:
      providers:
        own: 'Нет'
        dostavista: 'Dostavista'
        yandex_go: 'Яндекс Доставка'
        broniboy: 'Broniboy'
        dc_last_mile: 'DC Last Mile'
        sber_last_mile: 'Sber Last Mile'

    notifications:
      ymaps:
        title: 'Яндекс Карты'
        message: 'Токен Яндекса заблокирован или недоступен'


  restaurants:
    tarif_restriction:
      title: 'Превышен лимит ресторанов'
      message: 'Смените тарифный план или отключите неактуальные заведения'

    add_restaurant: 'Добавить ресторан'

    no_group: 'Без группировки'

    remove_button: 'Удалить'
    cancel_button: 'Отменить'
    save_button: 'Сохранить'

    remove_confirm: 'Удалить ресторан?'
    cancel_confirm: 'Отменить изменения?'

    validate_name_phone_address: 'Название, телефон и адрес не должны быть пустыми!'

    zero_data:
      message: 'Ресторан не выбран'
      hint:  'Выберите ресторан, чтобы посмотреть подробную информацию или начать редактирование.'

    edit:
      header:
        tabs:
          common: 'Общие настройки'
          dine_in: 'Заказ в зале'
      dine_in:
        table:
          header: 'Стол'
          new_table_name: 'Cтол №{{number}}'
          name: 'Название стола'
          add: 'Добавить стол'
          save: 'сохранить'
          delete: '×'
          qr: 'QR'
          delete_confirm: 'Вы действительно хотите удалить столик?'
      is_new: 'Добавление нового ресторана'
      form_title: 'Заполните форму ниже и нажмите сохранить'
      normal_mode_text: 'Включен обычный режим'
      normal_mode_caption: 'Будут использованы стандартные настройки из зоны доставки'
      not_running: 'Заведение не работает'
      not_running_caption: 'Включите, чтобы начать прием заказов в это заведение.'
      common_destroy: 'Обычное удаление'
      common_destroy_caption: 'Включите, чтобы принудительно удалить ресторан.'
      force_destroy: '⚠️ Принудительное удаление ⚠️'
      force_destroy_caption: 'Обратите внимание, в случае принудительного удаления будут так же удалены все заказы и зоны доставки, относящиеся к данному ресторану.<br>
                              Без возможности восстановления!'
      timezone_caption: '⚠️ В организации установлен {{timezone}}'
      off_reason_caption: 'В этом поле вы можете указать причину отключения ресторана'
      auto_enable_timezone: 'По наступлении указанного времени прием заказов в этот ресторан будет автоматически включен, а менеджеры получат уведомление на электронную почту.'
      labels:
        name: 'Название'
        phone: 'Телефон'
        address: 'Адрес'
        city: 'Город'
        description: 'Описание'
        availability: 'Доступность заказа'
        rush_mode: 'Режим высокого спроса'
        is_delivery: 'Режим работы'
        deletion: 'Удаление'
        location: 'Местоположение'
        timezone: 'Часовой пояс ресторана'
        external_id: 'Внешний код'
        terminal_id: 'ID терминала'
        order_number_prefix: 'Префикс номера заказа'
        off_reason: 'Причина отключения'
        auto_enable: 'Когда автоматически включить ресторан'
        address_comment: 'Комментарий к адресу'
        parent_restaurant: 'Родительский ресторан'
        timetables: 'Время работы'

      placeholders:
        name: 'Введите название'
        phone: 'Введите номер телефона'
        address: 'Введите название улицы'
        city: 'Введите город'
        location: 'Если нужно пояснение к адресу (используется при интеграции с аутсорсом доставки)'
        timezone: 'Часовой пояс ресторана'
        external_id: 'Нужен для интеграции с внешними сервисами'
        terminal_id: 'Нужен для интеграции с внешними сервисами'
        order_number_prefix: 'Переопределение префикса для заказа'
        off_reason: 'Уточните причину'
        description: 'Описание для страницы ресторана в приложении и на сайте'
        address_comment: 'Если нужно пояснение к адресу (используется при интеграции с аутсорсом доставки)'

      is_running: 'Заведение работает'
      is_running_caption: 'Выключите, чтобы остановить прием заказов в это заведение.
                          Отключенные рестораны не учитываются в тарифных ограничениях.'
      rush_mode_text: '🔥 Включен режим высокого спроса'
      rush_mode_caption: 'Будут использованы особые настройки для этого режима из зоны доставки'

      default_for_city_text: 'Выбирать по умолчанию'
      default_for_city_caption: 'Данный ресторан будет выбираться по умолчанию при выборе города'

      is_delivery_text: 'Показывать адрес клиентам'
      is_delivery_hint: 'Выключите этот признак, если ресторан работает только на доставку и клиентам не нужно знать его адрес.
                          В этом случае вы будете видеть заведение на карте, а клиенты будут видеть только номер телефона.'

  organizations:
    add_button: 'Добавить организацию'
    delete_button: 'Удалить'
    cancel_button: 'Отменить'
    save_button: 'Сохранить'
    add_button: 'Добавить'

    validate_name_host: 'Имя и хост не должны быть пустыми!'
    cancel_confirm: 'Отменить изменения?'
    remove_confirm: 'Удалить организацию?'

    zero_data:
      message: 'Организация не выбрана'
      hint: 'Выберите организацию, чтобы посмотреть подробную информацию или начать редактирование.'
    name:
      label: 'Имя'
      placeholder: 'Введите '

    phone:
      label: 'Телефон'
      placeholder: 'Введите номер телефона'

    host:
      label: 'Домен'
      placeholder: 'Введите поддомен *.smartomato.ru'

    login:
      label: 'Введите логин'
      placeholder: 'Логин'

    password:
      label: 'Пароль'
      placeholder: 'Введите пароль'

    about:
      label: 'Описание'
      placeholder: 'Описание'

  zone_templates:
    header: 'Добавить условие доставки в'

    switch:
      delivery: 'Доставка'
      takeaway: 'Самовывоз'
      dine_in: 'Заказ в зале'

    new_object_default_name:
      dine_in: 'Условия заказа в зале'
      delivery: 'Новая зона доставки'
      takeaway: 'Пункт самовывоза'

    header_description: 'Вы можете добавлять зоны курьерской доставки или точки самовывоза'
    draw_description: 'Если ни одна из предустановленных зон вам не подходит, вы можете нарисовать свою'
    draw_description_no_templates: 'Используйте карту, чтобы задать регион зоны'
    draw_button: 'Нарисовать зону'
    choose_zone_header: 'Используйте один из шаблонов'
    choose_zone_placeholder: 'Поиск'
    nothing_found: 'Зона не найдена'
    draw_zone_header: 'Нарисуйте зону на карте'
    add_takeaway: 'Создать пункт самовывоза'
    takeaway_note: 'Для создания пункта самовывоза в данном ресторане вам необходимо задать условия работы, такие как минимальный заказ, режим работы пункта и время приготовления.'
    dine_in_note: 'Чтобы включить возможность принимать заказы в зале в данном ресторане, вам необходимо задать условия: режим работы зала и некоторые другие параметры.'
    add_dine_in: 'Задать условия для заказа в зале'


  orders_map:
    no_current:
      title: 'Нет текущих заказов'
      text: 'Сюда попадут новые заказы или заказы, требующие обработки'
    no_delayed:
      title: 'Нет отложенных заказов'
      text: 'Сюда попадут заказы, которые пока не требуют вашего вмешательства'

    courier_popup:
      statuses:
        offline:          'Не работает'
        free:             'Свободен'
        delivering:       'Доставляет заказ по адресу <strong>{{address}}</strong>'
        picking_up_order: 'Направляется за заказом в <strong>{{restaurant}}</strong>'

  history:
    change_name:
      delivery_price:   'Стоимость доставки'
      delivery_at:      'Время доставки'
      cooking_start_at: 'Начало приготовления'
      status:           'Статус'
      courier_id:       'Курьер'
      pick_up_at:       'Время забора'
      contact_name:     'Имя'
      contact_phone:    'Телефон'

  import:
    status:
      free:     'Свободен'
      upload:   'Загрузка'
      queued:   'В очереди'
      working:  'Выполняется'

  modifier_group:
    new_group: 'Новая группа модификаторов'
    edit:
      back_button: 'Назад'
      header: ''
      subheader: 'Группа модификаторов'

      photo:
        label: "Фото модификатора"
        upload: "Загрузить фото"

      name:
        label: 'Название'
        placeholder: 'Название группы модификаторов'
      visible:
        label: 'Отображать'
      prompt:
        label: 'Предложение к использованию'
        placeholder: 'Например, «Выберите прожарку»'
      minmax:
        label: 'Ограничение количества'
      min:
        label: 'Не менее'
        placeholder: '-'
      max:
        label: 'Не более'
        placeholder: '-'
      view_type:
        label: 'Как отображать'
        checkbox: 'Checkbox'
        select: 'Select'
        stepper: 'Stepper'
      external_id:
        label: 'Внешний ID'
        placeholder: 'ID'
      modifiers:
        new_modifier: 'Новый модификатор'
        restaurant_price: 'Цена в {{restaurant}} ({{priceUnit}})'
        header: 'Набор модификаторов'
        comment: 'Укажите список возможных опций'
        default: 'По умолчанию'
        name:
          label: 'Название'
          placeholder: 'Например, «Medium rare»'
        price:
          label: 'Цена'
          placeholder: '—'
        external_id:
          label: 'Внешний id'
          placeholder: '—'

      buttons:
        save: 'Сохранить'
        delete: 'Удалить'
        cancel: 'Отменить'
        add: 'Добавить модификатор'

    availability:
      title: 'Доступность модификаторов в ресторане'
      caption: 'Здесь вы можете скрыть модификатор из меню ресторанов'
      loading: 'Загружается'

  general_parameters:
    labels:
      site_name: 'Сайт доступен по адресу'
      site_name_caption: 'Адрес сайта вы можете изменить в разделе "Настройки организации"'
      organization_logo: 'Логотип'
      organization_name: 'Название организации'
      organization_about: 'Описание организации'

  static_pages:
    header: 'Список страниц'
    zero_data:
      search: 'Нет доступных страниц'
    table:
      content:
        name: 'Название'
        slug: 'Адрес'
        position: 'Позиция'
        show_in_app: 'Отображается в приложении'
        show_in_web: 'Отображается на сайте'
        page_type: 'Тип страницы'
      types:
        html: 'HTML'
        collection: 'Коллекция'
      filters:
        visibility: 'Видимость'
    edit:
      header: 'Редактирование страницы'
      subheader: 'Заполните форму ниже и нажмите сохранить, пожалуйста'
      photo:
        label: 'Фото'
        placholder: 'Фото в карточке дочерней страницы'
      title:
        label: 'Заголовок'
        placeholder: 'Заголовок в карточке дочерней страницы'
      excerpt:
        label: 'Краткое описание'
        placeholder: 'Описание в карточке дочерней страницы'
      name:
        label: 'Название'
        placeholder: 'Название страницы'
      slug:
        label: 'Путь'
        placeholder: 'Путь страницы'
      position:
        label: 'Порядок отображения'
        placeholder: 'Порядок отображения'
      content:
        label: 'Контент страницы'
      parent:
        label: 'Родительская страница'
        placeholder: 'Выберите родительскую страницу'
      childs:
        label: 'Дочерние страницы'
        placeholder: 'Выберите вложенные страницы'


  promos:
    table:
      content:
        name: 'Название'
        is_working: 'Активна'
        actual_till: 'Срок действия'
        restaraunt: 'Рестораны'
        sources: 'Источники'
        priority: 'Приоритет'
        visibility: 'Видимость'
      filters:
        is_active:
          label: 'Активна'
          active: 'Да'
          not_active: 'Нет'
        date_range: 'Срок действия акции'
    confirm:
      delete: 'Удалить акцию?'

    buttons:
      add: 'Добавить'

    zero_data:
      active: 'У вас нет действующих акций'
      archive: 'Нет архивных акций'
      search: 'Нет доступных акций'
    zero_data_caption:
      active: 'Добавляйте акции, чтобы увеличивать средний чек или частоту заказов'
      archive: 'Добавляйте акции, чтобы увеличивать средний чек или частоту заказов'

    edit:
      back_button: 'Назад'
      header: 'Редактирование акции'
      subheader: 'Заполните форму ниже и нажмите сохранить, пожалуйста'

      menu:
        main: 'Общие данные'
        conditions: 'Условия'
        bonuses: 'Бонусы'

      name:
        label: 'Название'
        placeholder: 'Название акции'
      description:
        label: 'Описание'
        placeholder: 'Описание'
      offer_description:
        label: 'Предложение для использования'
        placeholder: 'Текст, который будет виден клиенту в случае возможности использования акции'
      is_working:
        label: 'Акция активна'
        caption: 'Позволяет временно отключить действие акции. Неактивные акции не будут показаны клиентам.'
      period:
        label: 'Срок действия'
        to: 'до'
      for_birthday:
        label: 'Акция к дню рождения'
        before_birthday: 'Активна до дня рождения'
        after_birthday: 'Активна после дня рождения'
        placeholder: 'кол-во дней'
        caption: 'Акция к дню рождения может начать действовать за указанное количество дней до и после дня рождения'
      timetable:
        enabled: 'Расписание включено'
        disabled: 'Расписание выключено'
      timetable_for_order_time:
        label: 'Учитывать время заказа'
        caption: 'Заданное расписание будет применяться к моменту размещения заказа, а не ко времени, на которое этот заказ делается'
      timetable_for_asap_only:
        label: 'Учитывать время заказа только для срочных заказов'
        caption: 'В случае, если заказ отложенный, вместо времени его размещения будет использоваться время, на которое он делается'
      priority:
        label: 'Приоритет акции'
        placeholder: 'целое положительное число'
        caption: 'Приоритет нужен для управления тем, как акции будут суммироваться.<br> В случае, если гостю подойдет несколько акций — будет выбрана одна или несколько с наибольшим приоритетом.'
      is_exclusive:
        label: 'Акция взаимоисключающая'
        caption: 'Позволяет запретить использование в одном заказе нескольких акций с одинаковым приоритетом.'
      sources:
        label: 'Ограничение по источникам заказа'
        unrestricted: 'Акция применима для всех источников заказа'
        restricted_header: 'Обратите внимание!'
        restricted_comment: 'Из-за ограничения по источникам заказа акция будет доступна клиентам только при оформлении заказа из указанных в списке источников'
      restaurants:
        label: 'Ограничение по ресторанам'
        unrestricted: 'Акция сработает для всех ресторанов'
        restricted_header: 'Обратите внимание!'
        restricted_comment: 'Из-за ограничения по ресторанам акция появится у клиента только после определения ресторана (после ввода адреса или выбора пункта самовывоза)'
      inversed_delay: 'Выключено по умолчанию'
      disposable: 'Одноразовая'
      for_referral: 'Для приглашенных (рефералов)'
      is_takeaway: 'Подходит для самовывоза'
      is_delivery: 'Подходит для доставки'
      is_dine_in: 'Подходит для заказа в зале'
      free_delivery: 'Бесплатная доставка'
      not_delivery_takeaway_warning: 'Чтобы акция сработала она должна подходить хотя бы для одного способа получения заказа'
      disable_bonus_getting: 'Не начислять баллы'
      disable_bonus_usage: 'Не списывать баллы'
      last_order:
        header: '«Последний заказ»'
        comment: 'Вы можете сделать акцию, которая будет срабатывать для гостей, у которых был хотя бы один заказ за указанное количество дней назад на сумму не менее указанной'
        days_count:
          label: 'Количество дней:'
          placeholder: 'Количество дней:'
        sum:
          label: 'Минимальная сумма заказа:'
          placeholder: 'Сумма'
      single_use_codes:
        header: 'Одноразовые промокоды'
        comment: 'В акции можно определить набор кодов, которые будут ее включать. Каждый код можно будет использовать только один раз.'
        enabled:
          label: 'Одноразовые коды'
          caption: 'Можно сформировать набор секретных кодов, каждый из которых можно будет использовать лишь один раз'
        stat:
          label: 'Количество кодов, добавленных акции'
          report: 'Отчет по использованию кодов'
          download: 'Выгрузить коды (.csv)'
          used: 'Из них использовано'
          available: 'Доступно к использованию'
          delete_unused: 'Удалить неиспользованные коды'
        create:
          title: 'Сгенерировать промокоды'
          title_more: 'Сгенерировать дополнительные промокоды'
          amount: 'Количество'
          length: 'Длина кода'
          button: 'Сгенерировать'
          comment: 'Вы можете создать сразу группу кодов по определенным правилам,
            укажите сколько кодов вам нужно и сколько символов они должны быть по длине.
            Чем больше символов, тем ниже вероятность, что клиент сможет их подобрать, но тем сложнее их вводить.'
          generate: 'Сгенерировать коды'
          cancel: 'Не генерировать коды'
          need_save: 'Генерация будет доступна после сохранения акции'
      promos_issue:
        header: 'Ручная и автоматическая выдача кодов клиентам'
        comment: 'Включите, чтобы настроить эту акцию таким образом, чтобы клиентам можно быть отправлять коды для доступа к ней'
        enable:
          label: 'Включить выдачу кодов с sms-уведомлением'
        issue_sms_text:
          label: 'Текст sms-сообщения'
          placeholder: 'Текст'
          example:
            label: 'Например:'
            text: '[name], в качестве извинения за опоздание при доставке заказа мы хотим подарить вам пиццу, укажите код [code] при следующем заказе'
        length:
          label: 'Длина кода'
          placeholder: 'кол-во символов'
          caption: 'Чем больше символов, тем ниже вероятность, что клиент сможет их подобрать, но тем сложнее их вводить.'
        ttl:
          label: 'Время жизни каждого кода, дней'
          placeholder: 'дней'
          caption: 'Через указанное количество дней код будет удален.<br>0 — не удалять коды никогда.'
        manual_enable: 'Разрешить ручную выдачу кодов клиентам'
      issue_late:
        header: 'Бонусы за опоздание'
        comment: 'Вы можете настроить эту акции таким образом, чтобы за каждый заказ, доставленный с опозданием клиенту отправлялось SMS с одноразовым кодом от этой акции'
        enable:
          label: 'Включить бонусы за опоздание'
        minutes_amount:
          label: 'Считать опозданием задержку больше чем, мин:'
          placeholder: 'мин.'
      codes:
        header: 'Многоразовые промокоды'
        comment: 'Можно задать код, который будет включать акцию.'
        code:
          label: 'Многоразовый промокод'
          placeholder: 'Секретный код'
          caption: 'Если задать промо-код для акции, то при формировании заказа у гостей появится
            возможность указать код. Код можно комбинировать с другими условиями акции. С этим кодом можно будет сделать любое количество заказов.'
      error_text:
        label: 'Текст ошибки для гостя'
        placeholder: 'Текст ошибки для гостя'
        caption: 'Если гость укажет правильный код, но акция не будет подходить по критериям — ему будет показан указанный текст.'
      required_all_dishes:
        header: 'Наличие в заказе всех указанных блюд'
        comment: 'Например, бесплатный напиток при заказе Куриного бургера, картофеля фри и салата «Коул Слоу»'
        label: 'Список блюд'
      required_any_dish:
        header: 'Наличие в заказе одного или нескольких блюд из указанного списка'
        comment: 'Например, бесплатный напиток при заказе четырех пицц с мясом, пепперони или грибами'
        label: 'Список блюд'
        number: 'Количество из списка блюд'
      required_any_dish_categories:
        label: 'Список категорий'
      client_requirements:
        header: 'Требования к клиенту'
        category:
          label: 'Категории клиентов'
          caption: 'клиент должен принадлежать одной из указанных категорий'
        restrict_category:
          label: 'Запретить определенные категории клиентов'
          caption: 'У клиента не должно быть ни одной из перечисленных категорий'
        recurrence:
          label: 'Возвращаемость клиента'
          caption: 'Клиент должен иметь одну из указанных возвращаемостей'
        order_sum:
          label: 'Сумма заказа'
          warning: 'Необходимо задать сумму заказа'
        count_order_sum_with_delivery:
          label: 'Учитывать стоимость доставки'
        repeatable_bonus:
          label: 'Может сработать несколько раз в одном заказе'
          caption: 'Например, <em>«за каждый бургер в заказе давать бесплатный напиток»</em>'
        for_new_client:
          label: 'Акция для нового клиента'
          caption: 'акция сработает для клиента, у которого еще не было ни одного заказа'
        nth_order:
          label: 'Номер заказа'
          caption: 'позволяет задать скидку за каждый указанный по счету заказ клиента, счет заказов ведется в период действия акции'
      bonuses:
        header: 'Бонусы'
        comment: 'Определяют результат применения акции в заказе'
        bonus_dishes:
          label: 'Добавить в заказ указанные блюда'
        bonus_price:
          label: 'Стоимость бонусных блюд'
          caption: 'Если хотите давать подарочные блюда по спец.цене, а не бесплатно'
        bonus_free_dishes:
          label: 'Предложить выбрать одно из указанных блюд'
        discount_percent:
          label: 'Скидка в процентах на заказ'
        discount_fixed:
          label: 'Фиксированная скидка на заказ'
        discount_dishes_percent:
          label: 'Скидка в процентах на блюда, указанные в условиях'
          caption: 'Позволяет задать скидку только на конкретные блюда, а не на весь заказ.'
          single_dish: 'только на одно блюдо из списка'
          cheapest:
            caption: 'По-умолчанию скидка пойдет на блюдо с наибольшей ценой. Но это можно поменять.'
            enable: 'давать скидку на самое дешевое блюдо'
        assign_tag:
          label: 'Назначить пользователю категорию'
        reset_tag:
          label: 'Сбросить у клиента указанные категории, при их наличии'
        issue_code:
          label: 'Создать и отправить код из акции'
      buttons:
        save: 'Сохранить'
        delete: 'Удалить'
        cancel: 'Отменить'



    add_promo: 'Добавить акцию'

    headers:
      index: 'Список акций'
      active: 'Действующие акции'
      archived: 'Архив акций'
      view_variant:
        cards: 'Карточки'
        table: 'Таблица'
        label: 'Вариант отображения'

    during_last_days:
      one:    'Был хотя бы 1 заказ за последний {{count}} день'
      few:    'Был хотя бы 1 заказ за последние {{count}} дней'
      many:   'Был хотя бы 1 заказ за последние {{count}} дней'
      other:  'Был хотя бы 1 заказ за последние {{count}} дней'

  promo_card:
    buttons:
      edit: 'редактировать'
    condition:
      dish_discount: 'Скидка на акционные блюда'
      next_order_in_days: 'Бонус за последний заказ:'
      next_order_min_sum: ' на сумму не менее '
      actual_from: 'Сроки проведения:'
      restaurants_selected: 'Рестораны:'
      restaurants_all: 'Все рестораны'
      promo_code: 'Промо-код:'
      it_free: 'В подарок'
      order_discount: 'Скидка на заказ'
      actual_till: 'Акция закончилась:'
      copy: 'Скопировать ссылку'
      copied: 'Ссылка скопирована'

  banners_index:
    header: 'Баннеры для витрины и приложения'
    create_button: 'Добавить'
    zero_data:
      header: 'У вас пока нет баннеров'
      caption: 'С помощью баннеров вы можете сообщить гостям какую-то информацию на сайте или в мобильном приложении'
  banners:
    disabled_text: 'К сожалению, вам недоступен <br>функционал баннеров'
    back_button: 'Назад'
    title: 'Редактирование баннера'
    main:
      name:
        label: 'Название'
        placeholder: 'Заголовок баннера (для внутреннего использования)'
      view_order:
        label: 'Порядок отображения: '
        placeholder: 'Числовой порядок (1, 2, 3...)'
        zero: 'не задан'
      url_web: 'Ссылка для витрины'
      url_mobile: 'Ссылка для приложения'
      platform:
        label: 'Где отображать баннер: '
        placeholder: 'Выберите платформы'
        web: 'На витрине'
        mobile_web: 'На витрине(мобильная версия)'
        mobile: 'В приложении'
        zero: 'не задан'
      photo:
        label: 'Картинка'
        storyLabel: 'Превью истории'
      restaurants:
        label: 'Ограничение по ресторанам'
      is_archived:
        label: 'Скрыть баннер'
      terms:
        label: 'Срок действия'
        to: 'до'
      story_frames:
        label: 'Кадры истории'
        create_frame: 'Добавить'
      has_clickable_popup: 'Попап по клику'
      has_popup_on_start: 'Попап на старте'
      popup_with_image:   'Показывать изображение в попапе'
      popup_is_blocking:  'Блокирующий попап'
      popup_title: 'Заголовок попапа'
      popup_content: 'Текст попапа'
      story_title: 'Заголовок истории'
      cancel_button: 'Текст для кнопки отмены'
      confirm_button: 'Текст для кнопки согласия'
      type:
        title: 'Тип контента'
        link: 'Ссылка'
        popup: 'Попап'
        story: 'История'
  adverts_index:
    header: 'Рекламные объявления и рассылка'
    create_button: 'Добавить'
    is_private: 'скрытое'
    zero_data:
      header: 'У вас пока нет рекламных объявлений'
      caption: 'С помощью объявлений вы можете сообщить гостям какую-то информацию: на сайте, push-сообщением или каким-то другим способом'
  adverts:
    tabs:
      table: 'Таблица'
      cards: 'Карточки'
    table:
      content:
        name: 'Название'
        recurrence: 'Ограничение по возвращаемости'
        client_tags: 'Категории клиентов'
        restaurants: 'Рестораны'
        channels: 'Типы каналов'
        created_at: 'Дата создания'
    disabled_text: 'К сожалению, вам недоступен <br>функционал рекламных объявлений'
    back_button: 'Назад'
    title: 'Редактирование объявления'
    menu:
      main: 'Общие данные'
      preview: 'Просмотр'
      delivery: 'Рассылка'
      stats: 'Статистика'
    main:
      name:
        label: 'Название'
        placeholder: 'Заголовок объявления'
      text:
        label: 'Текст'
        placeholder: 'Подробный текст'
      action:
        label: 'Ссылка-действие'
        placeholder: 'Ссылка с кнопки'
      photo:
        label: 'Картинка'
      is_private:
        label: 'Непубличная акция'
        on_comment: 'Сейчас это объявление будет видно только по прямой ссылке — тем, кому сделана рассылка'
        off_comment: 'Сейчас это объявление будет отображаться всем при входе на сайт или в приложение'
      is_archived:
        label: 'Скрыть объявление'
      terms:
        label: 'Срок действия'
        to: 'до'
    preview:
      link: 'Ссылка на объявление:'
    delivery:
      intro: 'Для запуска рассылки отберите клиентов, которым должна быть отправлена эта реклама.<br>Рассылка может быть проведена сразу через SMS либо вначале попытаться через push-уведомление, а уже потом через sms.'
      restaurants:
        label: 'Ограничение по ресторанам'
        placeholder: 'Не ограничивать по ресторанам'
      recurrence:
        label: 'Ограничение по возвращаемости'
        placeholder: 'Все'
      were_orders:
        label: 'Был хотя бы один заказ в период'
        from: 'с'
        to: 'по'
      were_no_orders:
        label: 'Не было ни одного заказа в период'
        not_yet: 'Пока этот критерий не работает'
        from: 'с'
        to: 'по'
      send_push:
        label: 'Push-уведомление'
        caption: 'Push-уведомление в iOS- и Android-приложение'
      send_whatsapp:
        label: 'WhatsApp'
        caption: 'Сообщение в WhatsApp'
      send_telegram:
        label: 'Telegram'
        caption: 'Сообщение в Telegram'
      send_vk:
        label: 'VK'
        caption: 'Сообщение в VK'
      send_auto:
        label: 'Автоматическая рассылка'
        caption: 'Автоматическая рассылка по каналам'
      send_sms:
        label: 'SMS'
        caption: ''
      text_sms:
        label: 'Текст SMS-сообщения'
        placeholder: 'Текст SMS-сообщения'
        caption: 'Чтобы разместить ссылку в тексте укажите ее в отдельном поле на этой форме, а в самом шаблоне используйте <code>{link}</code>.
          Тогда в момент рассылки вместо нее будет сформирована уникальная для каждого получателя ссылка.
          Это поможет нам рассчитать конверсию по рассылке.
          <br>
          Чтобы вставить имя клиента в сообщение, используйте конструкцию [name].'
      push_text:
        label: 'Текст Push-уведомления'
        placeholder: 'Текст Push-уведомления'
        caption: 'В тексте не нужно использовать ссылки, зато можно эмоджи 😉'
        error_text: 'Длина текста Push-уведомления не должна превышать 260 символов'
      push_title:
        label: 'Заголовок Push-уведомления'
        placeholder: 'Заголовок Push-уведомления'
        caption: 'Оставьте пустым, чтобы в качестве заголовка использовалось названиие приложения.<br>Рекомендуем задать не более 65 символов.'
      whatsapp_text:
        label: 'Текст WhatsApp-сообщения'
        placeholder: 'Текст WhatsApp-сообщения'
        caption: 'Чтобы разместить ссылку в тексте укажите ее в отдельном поле на этой форме, а в самом шаблоне используйте <code>{link}</code>.
          Тогда в момент рассылки вместо нее будет сформирована уникальная для каждого получателя ссылка.
          Это поможет нам рассчитать конверсию по рассылке.
          <br>
          Чтобы вставить имя клиента в сообщение, используйте конструкцию [name].'
      telegram_text:
        label: 'Текст WhatsApp-сообщения'
        placeholder: 'Текст WhatsApp-сообщения'
        caption: 'Чтобы разместить ссылку в тексте укажите ее в отдельном поле на этой форме, а в самом шаблоне используйте <code>{link}</code>.
          Тогда в момент рассылки вместо нее будет сформирована уникальная для каждого получателя ссылка.
          Это поможет нам рассчитать конверсию по рассылке.
          <br>
          Чтобы вставить имя клиента в сообщение, используйте конструкцию [name].'
      vk_text:
        label: 'Текст WhatsApp-сообщения'
        placeholder: 'Текст WhatsApp-сообщения'
        caption: 'Чтобы разместить ссылку в тексте укажите ее в отдельном поле на этой форме, а в самом шаблоне используйте <code>{link}</code>.
          Тогда в момент рассылки вместо нее будет сформирована уникальная для каждого получателя ссылка.
          Это поможет нам рассчитать конверсию по рассылке.
          <br>
          Чтобы вставить имя клиента в сообщение, используйте конструкцию [name].'

      link:
        label: 'Ссылка'
        placeholder: 'Текст Push-уведомления'
        caption: 'Если хотите, чтобы при входе на сайт клиенту отобразилось само объявление — добавьте следующий код в конце:'
        notice: 'ссылка будет сокращена, чтобы уменьшить количество sms и считать статистику переходов'
      promo:
        label: 'Акция, для расчета конверсии'
        no_promos: 'У вас пока нет ни одной акции. Добавьте акцию с промокодом и укажите ее здесь, это поможет в расчете конверсии'
        caption: 'Все заказы, совершенные с применением выбранной акции будут учтены как целевые в статистике рассылки этого объявления'
      execution:
        status_label: 'Статус:'
        counting: 'Ищем клиентов по указанным критериям...'
        found: ' По указанным критериям найдено: '
        execute_button: 'Запустить рассылку'
      scheduled_at:
        label: 'Запланировать рассылку'
      cancel:
        cancel_button: 'Отменить рассылку'
    stats:
      header: 'Статистика проведённой рассылки'
      loading: 'Загружаем статистику...'
      transport: 'Канал доставки:'
      sent: 'Отправлено:'
      received: 'Получено:'
      shown: 'Доставлено (СМС):'
      opened: 'Открыто:'
      orders_made: 'Сделано заказов:'
      average_total: 'Средний чек:'
      sum_total: 'Общая выручка:'
      income_per_sent: 'Выручка на одно объявление:'

      empty_stat: 'По этому объявлению пока нет статистики рассылки'
      empty_promo:
        header: 'В объявлении не указана целевая акция — расчет конверсии будет неточный'
        comment: '<p>Целевая акция помогает системе отличить заказы, которые клиенты сделали по этому объявлению.</p><p>В конверсии будут учтены все заказы, в которых была применена указанная акция</p>'
  loyalties_index:
    header: 'Программы лояльности'
    create_button: 'Добавить'
    zero_data:
      header: 'У вас пока нет программ лояльности'
      caption: 'С помощью программ лояльности вы сможете привлечь и удержать клиентов с помощью поощрений в виде скидок или бонусов.'
  loyalties:
    new: 'Программа лояльности'
    disabled_text: 'К сожалению, вам недоступен <br>функционал программ лояльности'
    back_button: 'Назад'
    title: 'Редактирование программы лояльности'
    main:
      name:
        label: 'Название'
        placeholder: 'Название'
      kind:
        label: 'Тип программы лояльности: '
        zero: 'не задан'
  bonus_categories_index:
    header: 'Бонусные категории'
    create_button: 'Добавить'
    zero_data:
      header: 'У вас пока нет бонусных категорий'
  bonus_category:
    new: 'Бонусная категория'
    disabled_text: 'К сожалению, вам недоступен <br>функционал бонусных категорий'
    back_button: 'Назад'
    title: 'Редактирование бонусной категории'
    main:
      name:
        label: 'Название'
        placeholder: 'Название'
      is_working:
        label: 'Категория активна'
      color:
        label: 'Цвет категории'
      sum_period:
        label: 'Какой период учитывать при суммировании заказов'
        placeholder: 'в днях'
      sum_upper_bound:
        label: 'Верхняя граница по сумме заказов для категории'
      bonus_percent:
        label: 'Процент начисляемых бонусов за заказ'
      expense_percent:
        label: 'Процент списания бонусов'
      external_id:
        label: 'Внешний id'
  client_tags_index:
    header: 'Теги'
    create_button: 'Добавить'
    zero_data:
      header: 'У вас пока нет тегов'
  client_tag:
    new: 'Тег'
    disabled_text: 'К сожалению, вам недоступен <br>функционал тегов'
    back_button: 'Назад'
    title: 'Редактирование тега'
    main:
      applicable_to_all: 'Применить к прошлым данным'
      name:
        label: 'Название'
        placeholder: 'Название'
      assign_type:
        label: 'При удовлетворении условий'
        autoassign: 'Ставить'
        autounassign: 'Снимать'
      period:
        label: 'Период отслеживания (дней)'
        from: 'с'
        to: 'по'
      num_of_orders: 'Количество заказов за период'
      spended_sum: 'Выручка по клиенту за период'
      order_frequency: 'Частота заказов за период'
      consumed_category:
        label: 'Заказ блюд из определенной категории'
        non_label: 'Отсутствие заказов из определенной категории'
      consumed_dish:
        label: 'Заказ определенного блюда'
        non_label: 'Отсутствие заказов определенного блюда'
      tags_to_unassign:
        label: 'Снять теги'
  communication_channels:
    incoming: 'Входящее сообщение'
    auth: 'Показать QR-код'
    header: 'Каналы коммуникации'
    columns:
      kind: 'Тип канала'
      status: 'Статус'
    kinds:
      whatsapp: 'WhatsApp'
      telegram: 'Telegram'
      push: 'Push-уведомления'
      sms: 'SMS'
      vk: 'ВКонтакте'
    status:
      active: 'Активен'
      enabled: 'Активен'
      disabled: 'Выключен'
      error: 'Ошибка'
    edit:
      priority: 'Приоритет'
      enabled:
        true: 'Канал активен'
        false: 'Канал выключен'
    chats:
      can_send: 'Введите сообщение'
      disabled: 'Нет доступных каналов'

  courier:
    new: 'Новый курьер'
    confirms:
      delete: 'Удалить курьера?'
    alerts:
      success:
        title: 'Сохранен!'
        message: 'Курьер успешно сохранен.'
      delete:
        title: 'Удален!'
        message: 'Курьер удален.'
      error:
        title: 'Ошибка!'

    add:
      courier_list: 'Список курьеров'
      add_button: 'Добавить'

    availability_everywhere: 'Курьер доступен во всех ресторанах'

    edit:
      buttons:
        back: 'Назад'
        assign: 'Назначить'
        cancel_assigment: 'Отменить назначение'
        cancel_order_in: 'Отменить заказ в'
        create_an_app_in: 'Создать заявку в'

      labels:
        avatar: 'Фото'
        name: 'Имя'
        phone: 'Телефон'
        login: 'Email'
        password: 'Пароль'
        repeat_password: 'Подтверждение пароля'
        courier_status: 'Заблокирован/Уволен'
        select_restaurant: 'Ограничение по ресторанам'
        courier_comment: 'Комментарий'

      placeholders:
        name: 'Имя'
        phone: 'Введите номер телефона'
        email: 'Введите email'
        password: 'Введите пароль'
        repeat_password: 'Подтвердите пароль'
        courier_status: 'Заблокирован/Уволен'
        select_restaurant: 'Ограничение по ресторанам'
        courier_comment: 'Комментарий'

      toggle:
        text: 'Заблокировать доступ к Смартомато'
        caption: 'Это сохранит учетную запись, но запретит доступ к Смартомато'

      caption:
        download_courier_app:
          text: 'Логин и пароль необходимы для входа в приложение курьера. Скачайте приложение курьера'
          ios: ' для iOS '
          android: ' для Android '
          and: 'и'

      is_edit: 'Редактирование курьера'
      is_new: 'Добавление нового курьера'
      form_edit_title: 'Заполните форму ниже и нажмите сохранить'
      courier_availability_about: 'Чтобы оператор при назначении курьера видел только курьеров, привязанных к ресторану, можно ограничить работу курьера некоторыми заведениями.'

      transport_type:
        label: 'Тип транспорта курьера'
        about: 'Способ передвижения, который курьер использует на доставках'
        types:
          public_transport: 'На общественном транспорте'
          walk: 'Пешком'
          car: 'На автомобиле'

    buttons:
      save: 'Сохранить'
      cancel: 'Отменить'
      delete: 'Удалить'

  delivery_zone:
    labels:
      color: 'Цвет заливки зоны'
      dine_in_name: 'Название набора условий'
      takeaway_name: 'Название пункта самовывоза'
      minimal_order_price: 'Мин. заказ ({{unit}})'
      free_delivery_price: 'Бесплатно с ({{unit}})'
      cooking_time: 'Время приготовл. (мин.)'
      cooking_time_auto: 'Автоматичесий расчет времени приготовления'
      delivery_zone_priority: 'Приоритет зоны'
      courier_order_fee: 'Гонорар курьера за доставку заказа в этой зоне:'
      delivery_time_expand_minutes: 'Продлить обычное время работы на (мин.)'
      delivery_zone_name: 'Название зоны'
      delivery_price: 'Цена доставки ({{unit}})'
      delivery_time: 'Общее время доставки (мин.)'
      transportation_time: 'Время перевозки (мин.)'
      outsource_provider: 'Аутсорсинг доставки:'
      outsource_subsidy: 'Субсидировать доставку на:'
      outsource_reject_from_price: 'Запрет на доставку при цене от:'
      outsource_free_delivery_price: 'Бесплатная доставка с:'
      service_charge: 'Сервисный сбор (%):'
      fixed_service_charge: 'Фиксированный сервисный сбор'
      delivery_zone_edit: 'Необходимо определить на карте границы зоны доставки:'
      special_condition_comment: 'Комментарий особого условия доставки'
    placeholders:
      no_outsource_provider: 'Нет'
    segments:
      settings: 'Настройки'
      advanced: 'Дополнительно'
      timetable: 'Расписание'
    buttons:
      delete: 'Удалить'
      save: 'Сохранить'
      area_edit: 'Редактировать область'
      area_define: 'Определить границы зоны доставки'
    validation:
      no_time_intervals: 'Укажите временные интервалы доставки для корректной работы инструментов логистики'
      time_not_valid: 'Общее время доставки должны быть больше суммы времени приготовления и времени перевозки'
    popover:
      help_timetable_text: '<p>Расписание работы позволяет задать время, на которое система будет допускать размещение заказов.</p>
                            <p>В заданное время курьеры доставят последний заказ и завершат работу.</p><p>Кухня освободится раньше в соответствии с временем доставки,
                            указанным в настройках зоны.</p><br>
                            <p>⚠️&nbsp;Задается не режим работы ресторана, а время когда заказ может быть доставлен.</p>
                            <p>Например, если ресторан работает до 22:00 и доставка занимает 1 час, то нужно указать окончание доставки в 23:00.
                            Фактически в ограничениях вы задаете время получения заказа.</p><p>Аналогично если ресторан открывается в 10:00 и тот же час на дорогу,
                            то в начале доставки нужно указать 11:00.</p>'
      help_delivery_process: '<p>В идеологии Смартомато процесс выполнения полученного от клиента заказа состоит из нескольких этапов:</p>
                            <ol><li>Подтверждение и согласование заказа</li>
                            <li>Отправка заказа на кухню</li>
                            <li>Приготовление и комплектация заказа</li>
                            <li>Забор заказа курьером</li>
                            <li>Перевозка заказа</li>
                            <li>Передача заказа клиенту</li></ol>
                            <p>Для того, чтобы наша система могла рассчитать все промежуточные этапы доставки и следила за отклонениями,
                            задайте время приготовления, перевозки и общее время доставки.
                            </p><p>Общее время доставки не должно быть меньше суммы времён приготовления и перевозки, но
                            может превышать её, если подразумевается длительный процесс согласования или иные
                            организационные процедуры, предшествующие началу приготовления.
                            </p></div>'
      help_priority_text: '<p>Вы можете определить несколько условий доставки, которые частично или полностью совпадают по области доставки.</p>
                          <p>Эти зоны могут быть привязаны как к одному ресторану, так и к разным.</p>
                          <p>Выбор подходящей зоны будет происходить по следующему принципу.</p>
                          <ol>
                            <li>Вначале Смартомато определит зоны, которые включают адрес клиента</li>
                            <li>Затем будут отобраны зоны, которые подходят по времени работы</li>
                            <li>После этого будут отобраны зоны, подходящие по размеру минимального заказа</li>
                          </ol>
                          <p>Если все еще подходит несколько зон, то Смартомато будет искать наиболее подходящую:</p>
                          <ol>
                            <li>Вначале будет выбрана зона с более высоким приоритетом (больше число — выше приоритет)</li>
                            <li>Если есть несколько с однинаковым приоритетом, то будет найдена зона с наименьшей ценой доставки / наименьшим минимальным заказом / наименьшим временем доставки</li>
                            <li>Если и их несколько, то сработает динамическое распределение с учетом текущей нагрузки:</li>
                          </ol>
                          <p>При динамическом распределении будет выбрана зона, привязанная к ресторану с меньшим количеством активных заказов в текущий момент — таким образом, если один адрес обслуживают несколько ресторанов, они будут нагружаться равномерно. </p>'
      help_advanced_courier_text: '<p>Если определить «гонорар курьера за заказ», то в отчетах по заказам, при группировке по курьеру,можно будет видеть сумму по доставленным курьером заказам.</p>
                                    <p>⚠️ Обратите внимание, что суммируются все заказы, даже отмененные, т.к. мы не знаем политику оплаты в вашей компании.
                                    Чтобы скорректировать данные в отчете вы можете фильтровать заказы по статусу.</p>'
      help_rush_mode_text: '<p>Этот режим позволит менеджерам в ресторанах переходить на более долгую либо более дорогую доставку когда у них слишком много заказов или какой-то другой форсмажор.</p>
                          <p>Можно оставить часть полей пустыми, тогда в случае «высокого спроса» соответствующий параметр меняться не будет.</p>'

    advanced_settings:
      title: 'Расширенные настройки'
      advanced_courier:
        title: 'Расчеты с курьером'
      rush_settings:
        title: 'Параметры для режима «высокого спроса» '
    timetable_title: 'Время приема заказов'
    add_takeaway_or_delivery: 'Добавить зону или самовывоз'
    is_takeaway: 'Параметры самовывоза'
    is_delivery: 'Параметры доставки'
    is_dine_in: 'Параметры заказа в зале'

  settings:
    analytics:
      title: 'Мета-теги'
      sub_title: 'Данные из этих тегов используются поисковыми системами и социальными сетями для формирования анонса на страницу'
      meta_title_caption: 'Будет также использовано в качестве &lt;title&gt; страницы'
      buttons:
        load_meta_image: 'Загрузить Meta Image'
        save: 'Сохранить'
        cancel: 'Отменить'
      placeholders:
        services:
          identificator: 'Идентификатор'
      labels:
        meta_title: 'Meta Title'
        meta_description: 'Meta Description'
        meta_image: 'Meta image'
      services:
        title: 'Сервисы веб-аналитики'
        subtitle: 'Возможность подключить сервисы веб-аналитики к витрине Смартомато'
        feature_text: 'Смартомато может фиксировать активность ваших клиентов в системах сбора статистики Мы записываем не только посещаемость, но и цели, которые позволят вам лучше понимать своих клиентов. А еще Смартомато интегрирован с Google Analitycs Enhanced Ecommerce чтобы можно было оценивать эффективность рекламных кампаний.'
        labels:
          ga: 'Google Analytics'
          metrika: 'Яндекс.Метрика'
          gtm: 'Google Tag Manager'
          fb_pixel: 'Facebook Pixel'
          vk_pixel: 'ВКонтакте Pixel'
          mail_pixel: 'Mail.Ru Counter ID'
          data_layer: 'Включить e-commerce трекинг в DataLayer'
        data_layer_caption: 'Виджет будет отправлять информацию о действиях гостей в DataLayer. '
        data_layer_more: 'Подробнее о DataLayer'
        examples:
          ga: 'Например: UA-61543473-1'
          metrika: 'Например: 21277873'
          gtm: 'Например: GTM-11XX1XX'
          fb_pixel: 'Например: 111111111111 (Числовой код из 12 и более цифр)'
          vk_pixel: 'Например: VK-RTRG-111111-aA1A1'
          mail_pixel: 'Например: 123456'
        events:
          open:
            modal:
              order: 'Открыли окно заказа'
              receipt: 'Открыли прошлый заказ'
              invite: 'Открыли диалог приглашения'
            configurator: 'Открыли большой/маленький конфигуратор'
            quick_configurator: 'и'
          copy_invite : 'Скопировали ссылку для приглашения'
          dish_click: 'Нажали на блюдо'
          dish_add: 'Добавили блюдо в корзину'
          show_delivery_zones: 'Открыли карту с зонами доставки'
          address_autodetect: 'Нажали на автоопределение адреса'
          click_pay: 'Нажали на кнопку «оплатить»'
          order_paid: 'Оплатили заказ'
          click_checkout:
            event: 'Нажали на кнопку «оформить заказ»'
            description:
              no_valid : 'Заказ создан (этих событий может быть меньше, если клиент некорректно заполнил форму)'
              and: 'и'
    business_role:
      zero_data:
        title:  'Пока не добавлено ни одной бизнес роли'
        caption: 'Добавляйте бизнес роли для более точного управления доступом и бизнес-процессами'
      list_business_role: 'Список бизнес ролей'
      add_new: 'Добавить'
      delete: 'Удалить бизнес роль?'
      cancel: 'Отменить изменения?'
      title:
        is_exist: 'Редактирование бизнес роли'
        is_new: 'Добавление новой бизнес роли'
      subtitile: 'Доступы к участкам системы Смартомато'
      labels:
        name: 'Название роли'
        permitted_statuses: 'Разрешенные статусы заказа'
        privileges: 'Права'
        subject: 'Участок'
        reports_access: 'Доступ к отчетам'
        can_assign_courier: 'Назначение курьеров на заказ'
      subject:
        table: 'Столы'
        courier: 'Курьеры'
        organization: 'Организация'
        draft_dish: 'Блюда'
        draft_category: 'Категории'
        modifier_group: 'Группы модификаторов'
        modifier: 'Модификаторы'
        modifier_scheme: 'Схема модификаторов в блюде'
        modifier_scheme_item: 'Группы в схемам модификаторов'
        delivery_zone: 'Зоны доставки'
        order: 'Заказы'
        client: 'Гости'
        client_tag: 'Теги гостей'
        staff_member: 'Сотрудники'
        service: 'Тарифные планы'
        service_subscription: 'Подписка'
        invoice: 'Счета'
        invoice_item: 'Детали счёта'
        billing_info: 'Биллинг'
        bank_details: 'Банковские реквизиты'
        theme: 'Шаблоны тем'
        skin: 'Тема оформления'
        order_item: 'Состав заказа'
        buddy: 'Участники заказа'
        promo: 'Акции'
        advert: 'Рассылки'
        banner: 'Баннеры'
        loyalty_program: 'Программы лояльности'
        business_role: 'Бизнес роли'
        cooking_line: 'Цеха приготовления'
        payment: 'Оплаты'
        dish: 'Блюда на сайте/приложении (только для чтения)'
        category: 'Категории на сайте/приложении (только для чтения)'
        api_user: 'Личный аккаунт'
        restaurant: 'Рестораны'
        brand: 'Бренд'
        dish_group: 'Группа блюд'
        organization_common_file: 'Общий файл организации'
        static_page: 'Статическая страница'
      actions:
        read: 'Просмотр'
        create: 'Создание'
        update: 'Обновление'
        destroy: 'Удаление'
        qr: 'Генерация QR-кода'
        publish: 'Публикация'
        stats: 'Статиcтика'
        upload_logo: 'Загрузка логотипа'
        remove_logo: 'Удаление логотипа'
        upload_favicon: 'Загрузка favicon'
        upload_meta_image: 'SEO изображения'
        import_menu: 'Импорт меню (API)'
        support_issue: 'Письма в поддержку'
        check_host: 'Изменение домена'
        reorder: 'Сортировка'
        upload_photo: 'Загрузка фото'
        upload_avatar: 'Загрузка аватара'
        update_priorities: 'Обновление приоритета заказов'
        delay_bonus: 'Бонус за задержку'
        status: 'Статус'
        receipt: 'Накладная'
        geocode: 'Геокодирование'
        reverse_geocode: 'Обратное геокодирование'
        assign_zone: 'Определение зоны'
        confirm: 'Подтверждение'
        set_client_sign: 'Подпись клиента'
        place: 'Размещение заказа'
        dispose: 'Списание'
        select_bonus_dish: 'Выбор подарка'
        validate: 'Валидация'
        logs: 'Логи'
        cancel_outsource: 'Отмена аутсорса'
        place_outsource: 'Размещение аутсорса'
        bonus_log: 'История бонусов'
        commit_bonus_amount: 'Изменение бонусов'
        switch: 'Смена подписки'
        detailed: 'Подробности счета'
        configure: 'Настройка'
        delete_photo: 'Удаление фото'
        select: 'Смена темы'
        create_promo_codes: 'Создание промокодов'
        issue_promo_code: 'Выдача промокодов'
        delete_unused_promo_codes: 'Удаление промокодов'
        promo_codes_usage: 'Статистика промокодов'
        clients_count: 'Количество гостей'
        execute: 'Запуск рассылки'
        cancel: 'Отмена рассылки'
        statistics: 'Статистика рассылки'
        stat: 'Лог аккаунта'
        availability: 'Доступность'
        checklist: 'Первоначальная настройка'
        menu: 'Меню'
        menu_export: 'Экспорт меню'
        categories: 'Категории'
        dies: 'Блюда'
        retry_pos_export: 'Повторить экспорт позиции'
        rate_processed: 'Оценить обработанные'
        unprocessed_counts: 'Необработанные счетчики'
        reset: 'Сброс'
        upload_file: 'Загрузить файл'
        upload_story_photo: 'Загрузка фотографии истории'
        reorder_story_frames: 'Изменение порядка кадров истории'
        upload_static_page_photo: 'Загрузка фотографии'
        upload_static_page_section_photo: 'Загрузка фотографии раздела'
        reorder_static_page_sections: 'Изменение порядка разделов'
      placeholders:
        name: 'Название роли'
        permitted_statuses: 'Разрешенные статусы заказа'
      staff_members_count: 'Сотрудников с данной ролью: {{staffMembersCount}}'
    staff:
      list_staff: 'Список сотрудников'
      add_new: 'Добавить'
      title:
        is_exist: 'Редактирование сотрудника'
        is_new: 'Добавление нового сотрудника'
      subtitile: 'Доступ сотрудников к системе, заведениям и прочим сервисам Смартомато'
      labels:
        staff_disabled: 'Заблокирован/Уволен'
        staff_role: 'Роль сотрудника'
        avatar: 'Аватар'
        name: 'Имя'
        phone: 'Телефон'
        login: 'Email (логин)'
        password: 'Пароль'
        repeat_password: 'Подтверждение'
        notifications: 'Уведомления'
        connect_sip: 'Подключить SIP'
        sip_login: 'Адрес SIP'
        sip_password: 'Пароль SIP'
        restaurant: 'Рестораны'
        cooking_line: 'Производственный цех'
      placeholders:
        name: 'Имя'
        phone: 'Введите номер телефона'
        login: 'Введите email'
        password: 'Введите пароль'
        repeat_password: 'Подтвердите пароль'
      staff_disabled:
        text: 'Заблокировать доступ к Смартомато'
        caption: 'Это сохранит учетную запись, но запретит доступ к Смартомато'
      sip_enabled:
        title: 'Настройки телефонии'
        text: 'уведомлять о новых звонках'
        caption: 'Подключить SIP аккаунт к системе заказов?'
      staff_restaurants: 'Какие рестораны доступны данному сотруднику?'
      staff_cooking_lines: 'В каких цехах работает сотрудник?'


      business_role:
        label: 'Бизнес роль'
        caption: '⚠️ Внимание: при выборе бизнес роли сотруднику будут выданы отдельные права, никак не связанные со стандартными ролями'
      staff_role:
        admin:
          title: 'Администратор'
          description: 'Полный доступ к управлению организацией'
        manager:
          title: 'Менеджер'
          description: 'Управление доступностью блюд в ресторанах'
        manager_logist:
          title: 'Менеджер-логист'
          description: 'Управление клиентами, полным циклом логистики и доступностью блюд'
        logist:
          title: 'Логист'
          description: 'Логистика заказов'
        regional_admin:
          title: 'Региональный администратор (франчайзи)'
          description: 'Может менять указанные рестораны и цены в них. Создавать сотрудников в указанных ресторанах.'
      notifications:
        name: 'Название'
      notification_url: 'для интеграции с API'
    sip:
      title: 'Настройки телефонии'
      explanation: '<p>Смартомато может интегрироваться с IP-телефонией и сильно упростить работу телефонного оператора.</p>
                    <p>Вы сможете узнавать кто звонит в колцентр еще до того, как снимете трубку. Имя клиента, его текущий заказ, история прошлых заказов — все, что нужно.</p>'
      disabled:
        before_link: 'В вашем тарифном плане нет возможности интеграции. Вы можете'
        link: ' сменить тарифный план '
        after_link: 'чтобы подключить интеграцию с телефонией.'
      enabled:
        before_link: 'Для настройки интеграции необходимо выбрать сотрудников, которые будут принимать звонки, в разделе'
        link: ' Сотрудники. '
        after_link: 'Для каждого сотрудника нужно указать sip-логин и пароль в секции «Телефония» на карточке редактирования.'
      staff_with_sip:
        title: 'В данный момент звонки будут принимать'
        go_to_staff: 'перейти к управлению принятием звонков'

    organization:
      title: 'Настройки организации'
      subtitle: 'Заполните форму ниже и нажмите сохранить, пожалуйста'
      caption:
        id: 'ID может быть нужен для интеграции, в частности для <a href="https://developer.smartomato.ru/widget">размещения виджета</a> Смартомато на вашем сайте'
      labels:
        id: 'ID организации'
        logo: 'Логотип'
        name: 'Название организации'
        phone: 'Телефон'
        about: 'Описание'
        hostname: 'Адрес сайта'
        advanced_head: 'Расширенные настройки витрины Смартомато'
        advanced_settings:
          head:
            caption:
              description: 'Этот код будет размещен в &lt;HEAD&gt; секции страницы. Здесь вы можете указать произвольный HTML, CSS или JavaScript (используйте теги &lt;STYLE&gt и &lt;SCRIPT&gt).'
              warning: 'Внимание!'
              ask_support_description_before: 'Код появляется на странице без публикации, будьте осторожны. Обратитесь в '
              ask_support: 'поддержку'
              ask_support_description_after: ', если вы не до конца понимаете, зачем это все нужно :) Будем рады помочь.'
          body:
            caption:
              description: 'Аналогично, но в конце страницы'
        advanced_body: 'Код для размещения в конце страницы'
        timezone: 'Часовой пояс'
        is_published: 'Публикация'
        vk: 'Вконтакте'
        whatsapp: 'WhatsApp'
      buttons:
        upload_logo: 'Загрузить логотип'
        change_host: 'Изменить'
        upload_favicon: 'Загрузить Favicon'
      is_published:
        text: 'Опубликовать ресторан'
        description: 'Доступен ли ресторан по указанному адресу?'
      placeholders:
        name: 'Название'
        phone: 'Введите номер телефона'
        about: 'Описание организации'
        advanced_head: 'Расширенные настройки сайта (секция HEAD)'
        advanced_body: 'Расширенные настройки сайта (секция BODY)'
      lang_settings_helper: 'Если вам нужно сменить валюту или языковые настройки организации — напишите нам в поддержку и мы поможем.'

    host:
      title: 'Изменение доменного имени'
      subtitile: 'Выбор адреса, по которому будет доступна витрина Смартомато'
      explanation:
        text: 'Для витрины Смартомато вы можете использовать адрес в зоне <b>*.smartomato.ru</b> или привязать собственный домен. Для адреса вида <b>имя_ресторана.smartomato.ru</b> достаточно выбрать любой незанятый адрес, и все заработает автоматически!'
        before_link: 'При использовании собственного адреса все немного сложнее, но мы подскажем.'
        link: 'Напишите нам в поддержкy'
        after_link: ', и мы постараемся помочь вам как можно скорее.'

    integrations:
      title: 'Интеграции в Смартомато'
      feature_text: 'Смартомато умеет взаимодействовать со многими сервисами, напишите нам и мы поможем всё настроить'
      feature:
        pos:
          title: 'Ресторанный учет'
          poster:
            title: 'Poster'
            description: 'Отправка подтвержденных заказов из Смартомато на кухню. Импортировать меню и ресторанов из Poster в Смартомато.'
          r_keeper:
            title: 'R-Keeper'
            description: 'Отправка подтвержденных заказов из Смартомато на кухню.'
          iiko:
            title: 'Iiko'
            description: 'Отправка подтвержденных заказов из Смартомато на кухню.'
          frontpad:
            title: 'Frontpad'
            description: 'Отправка подтвержденных заказов из Смартомато на кухню.'
          sbis:
            title: 'СБИС Presto'
            description: 'Отправка подтвержденных заказов из Смартомато на кухню.'
        aquiring:
          title: 'Эквайринг'
          yandex:
            title: 'Яндекс.Касса'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир, JCB, Diners Club, American Express. Яндекс.Деньги. QIWI Кошелёк.'
          cloud_payments:
            title: 'Cloudpayments'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир.'
          sberbank:
            title: 'Сбербанк'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир.'
          ibox:
            title: 'iBox'
            description: 'Прием безналичных платежи с помощью смартфона и мобильного терминала. Банковские карты Visa, Mastercard, Maestro, Мир'
          pay_keeper:
            title: 'PayKeeper'
            description: 'Эквайринг от банков: ВТБ, Сбербанк, Промсвязьбанк, Банк Открытие, Московский Кредитный Банк, Банк Русский Стандарт, ТрансКапиталБанк, Газпромбанк, БАНК УРАЛСИБ, Банк Санкт-Петербург, УБРиР, ПОЧТА БАНК, КИВИ Банк'
          alfa_bank:
            title: 'Альфа Банк'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир.'
          tinkoff:
            title: 'Тинькофф'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир.'
          yandex_check:
            title: 'Яндекс.Чек'
            description: 'Прием оплаты онлайн. Банковские карты Visa, Mastercard, Maestro, Мир.'
        loyalty:
          title: 'Системы лояльности'
          sber_food:
            title: 'СберФуд'
            description: 'Рестораны, использующие СберФуд, отслеживают данные об использовании бонусов в интерфейсе Смартомато, а гости ресторана — накапливают и тратят бонусы при заказе доставки.'
          premium_bonus:
            title: 'Premium Bonus'
            description: 'Единый бонусный счет гостя — при посещении ресторана оффлайн и при заказе доставки. Двусторонняя синхронизация данных о клиентах, накоплении и списании бонусов.'
          iiko_card:
            title: 'iikoCard'
            description: 'Бонусно-депозитная система, назначение которой – управление отношениями с постоянными гостями, поддержка схем корпоративного питания.'
          primehill:
            title: 'PrimeHill'
            description: 'Удобная система автоматизирования маркетинговых коммуникаций.'
        analytics:
          title: 'Сквозная аналитика'
          calltouch:
            title: 'Calltouch'
            description: 'Автоматическая передача информации о заказах по телефону в виде сделок в Calltouch и присвоение рекламных источников.'
        delivery_outsource:
          title: 'Аутсорс доставки'
          yandex_go:
            title: 'Яндекс.Доставка'
            description: 'Автоматическое создание и передача заявки на доставку из Смартомато в Яндекс.Доставку, синхронизация статусов заказа, настройки субсидирования и подробные отчеты.'
          dostavista:
            title: 'Достависта'
            description: 'Полная автоматизация: расчет стоимости и времени доставки, передача заявки на доставку, синхронный обмен статусами заказа, формирование отчетности.'
          broniboy:
            title: 'Broniboy'
            description: 'Автоматическое создание и передача заявки на доставку из Смартомато в Broniboy, синхронизация статусов заказа, настройки субсидирования и подробные отчеты.'
        messaging:
          title: 'SMS и мессенджеры'
          main_sms:
            title: 'MainSMS'
            description: 'SMS клиентам с выбранным именем отправителя.'
          smsc:
            title: 'СМС-центр'
            description: 'SMS клиентам с выбранным именем отправителя.'
          megafon:
            title: 'Мегафон'
            description: 'SMS клиентам с выбранным именем отправителя.'
          infobip:
            title: 'Infobip'
            description: 'SMS клиентам с выбранным именем отправителя. Отправка сообщений в мессенджеры — в разработке'
          whatsapp:
            title: 'WhatsApp'
            description: 'Отправление сообщения от официального аккаунта бизнеса пользователям мессенджера WhatsApp.'
          sms_agent:
            title: 'СМС-агент'
            description: 'SMS клиентам с выбранным именем отправителя.'
          beeline:
            title: 'Билайн'
            description: 'SMS клиентам с выбранным именем отправителя.'
          mts:
            title: 'МТС-маркетолог'
            description: 'SMS клиентам с выбранным именем отправителя.'
          sms_aero:
            title: 'SMS Aero'
            description: 'SMS клиентам с выбранным именем отправителя.'
        aggregators:
          title: 'Агрегаторы'
          yandex_eda:
            title: 'Яндекс.Еда'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Яндекс.Еду (импорт, уведомления, отмена, обновление статуса).'
          delivery_club:
            title: 'Delivery Club'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Delivery Club (импорт, уведомления, отмена, обновление статуса).'
          broniboy:
            title: 'Broniboy'
            description: 'Выгрузка меню ресторана в сервис. Обработка полученных заказов (импорт, уведомления, отмена, обновление статуса).'
          obed_ru:
            title: 'Обед.ру'
            description: 'Импорт заказов, полученных через Обед.ру'
          zakazaka:
            title: 'ЗакаЗака'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через ЗакаЗаку (импорт, уведомления, отмена, обновление статуса).'
          chibbis:
            title: 'Chibbis'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Chibbis (импорт, уведомления, отмена, обновление статуса).'
          glovo:
            title: 'Glovo'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Glovo (импорт, уведомления, отмена, обновление статуса).'
          vk:
            title: 'Vk'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Vk (импорт, уведомления, отмена, обновление статуса).'
          sbermarket:
            title: 'Sbermarket'
            description: 'Выгрузка меню ресторана в сервис. Обработка заказов полученных через Сбермаркет (импорт, уведомления, отмена, обновление статуса).'
      buttons:
        connect: 'Подключить'
    payments:
      title: 'Способы оплаты заказа клиентами'
      subtitile: 'Управление доступность выбора способов оплаты при формировании заказа'
      feature:
        description: 'Укажите способы оплаты, которые сможет выбрать клиент при формировании заказа. Обратите внимание, некоторые способы оплаты требуют дополнительные настройки.'
        cash:
          title: 'Наличные при получении'
          description: 'Оплата производится вашему курьеру, при получении заказа. В этом случае на форме заказа будет вопрос о необходимости курьеру иметь при себе сдачу с определенной клиентом суммы. Для работы этого сервиса не требуется никаких дополнительных настроек.'
        card_online:
          title: 'Картой онлайн'
          caption:
            before_support: 'После оформления заказа клиенту будет предложено ввести данные карты для оплаты заказа. Для работы этого способа оплаты необходима интеграция с интернет эквайрингом, это несложно — '
            support: 'напишите нам'
            after_support: ' и мы все сделаем.'
        courier_card:
          title: 'Картой при получении'
          description: 'Такой способ оплаты возможен, если ваши курьеры имеют мобильные терминалы. В <a href="https://play.google.com/store/apps/details?id=ru.smartomato.order_machine" target="_blank">курьерском приложении Смартомато</a> есть интеграция с <a href="http://iboxmpos.com/" target="_blank">iboxPro</a>, сервисом, который позволяет принимать карты используя смартфон.'
    profile:
      title: 'Настройки профиля'
      subtitle: 'Здесь вы можете отредактировать свой профиль'
      labels:
        photo: 'Аватар'
        name: 'Имя'
        phone: 'Телефон'
        login: 'Email (логин)'
        password: 'Пароль'
        password_repeat: 'Подтверждение'
      placeholders:
        name: 'Имя'
        phone: 'Введите номер телефона'
        login: 'Введите email'
        password: 'Введите пароль'
        password_repeat: 'Подтвердите пароль'
    developer_settings:
      title: 'Дополнительные возможности'
      subtitle: 'Раздел настроек и функций для опытных пользователей'
      feature:
        import_menu:
          title: 'Импорт меню'
          description: '<p>Пакетная загрузка меню организации из JSON-файла. Перед использованием ознакомьтесь с описанием формата файла в <a href="http://developer.smartomato.ru/api">документации для разработчиков Смартомато.</a></p>
                       <p>Внимание! Прежнее меню будет полностью заменено на импортируемое, что может привести к потере статистики. </p>'
        export_menu:
          title: 'Экспорт меню'
          description: '<p>Экспорт меню в виде JSON-файла</p>'
          action: 'Экспортировать'
          description_yml: '<p>Экспорт меню в виде YML-файла</p>'
          all_menu: 'Все меню'


        import_clients:
          title: 'Импорт клиентов'
          description: '<p>Пакетная загрузка данных о клиентах организации из JSON-файла. Перед использованием ознакомьтесь с описанием формата файла в
                        <a href="http://developer.smartomato.ru/api">документации для разработчиков Смартомато.</a></p>'
          label: 'Удалить ранее созданных клиентов'
        board2:
          title: 'Board2'
          description: '<p>Board2 – это отдельный интерфейс для настройки интеграций и специфических особенностей работы Смартомато.</p>
                        <p><a href="//smartomato.ru/board2" target="_blank">Открыть в новой вкладке</a></p>'
    interface:
      title: 'Настройки интерфейса'
      subtitle: 'Сохраняются параметры работы для конкретного браузера'
      feature:
        language:
          label: 'Язык интерфейса кабинета управления'
          caption: 'Эта настройка меняет ТОЛЬКО интерфейс кабинета в текущем браузере, никакие настройки организации изменены не будут'
        low_perfomance:
          description: 'Включите, если у вас много заказов, компьютер не справляется и интерфейс теряет отзывчивость'
          disable: 'Режим по умолчанию, без ограничений'
          enable: 'Теперь интерфейс выводит меньше информации и старается ее реже обновлять'
        hide_map:
          description: 'Не отображать карту на закладке с заказами'
          enable: 'Карта скрыта, это также снизит нагрузку на компьютер'
          disable: 'Карта будет отображаться'
        map_mouse_wheel:
          description: 'Управлять масштабом карты при помощи колесика мыши'
          enable: 'Колесико мыши будет менять масштаб'
          disable: 'Колесико мыши будет прокручивать'
        check_interval:
          description: 'Периодичность обновления чекпоинтов в заказах'
          enable: 'Установлен интервал обновления {{interval}} мин.'
        notification_duration:
          description: 'Как долго показывать всплывающее уведомление'
          enable: 'Уведомления будут скрываться через {{interval}} сек.'
        hide_order_notifications:
          description: 'Скрыть уведомления о новых заказах и смене их статусов'
          enable: 'Уведомления скрыты'
          disable: 'Уведомления отображаются'
        hide_pickup_orders_at_now:
          description: 'Скрывать заказы на самовывоз в списке заказов "сейчас"'
          enable: 'Заказы на самовывоз скрыты'
          disable: 'Отображаются все заказы'
        sound_notifications:
          description: 'Проигрывать звуковые оповещения при поступлении нового заказа'
          enable: '<br>Звуковые оповещения включены!'
        sound_notifications_verbose:
          description: 'Проигрывать звуковые оповещения при любом событии (не рекомендуется)'
          enable: '<br>🎉🥁🥳🎊!'
        sound_notifications_repeat:
          description: 'Повторять звуковые оповещения при поступлении нового заказа'
          enable: '<br>Повтороение звуковых оповещений включено!'
        repeat_interval:
          description: 'Периодичность повторения звуковых оповещений'
          enable: 'Интервал повторения {{interval}} сек.'
        integrations_settings:
          description: 'Открывать настройки интеграций внутри панели управления'
          enable: '<br>Настройки интеграций теперь не в отдельном окне!'
        hide_later_orders_on_map:
          description: 'Скрывать на карте заказы «Позже»'
          enable: '<br>На карте будут появляться только заказы «Сейчас»'
        hide_unauthorized_couriers:
          description: 'Скрывать неавторизованных курьеров на карте'
          enable: '<br>На карте будут отображаться только работающие курьеры'
        show_button_for_optional_modifiers:
          description: 'Отдельная кнопка для необязательных модификаторов в карточке заказа'
          enable: '<br>Обязательные модификаторы будут по клику на блюдо, необязательные - по кнопке возле блюда'
        show_dish_photo_in_order_card:
          description: 'Показывать фото блюд в карточке заказа'
          enable: '<br>Фото блюд в карточке заказа включены'
        show_assigned_courier_in_order_card:
          description: 'Показывать выбранного курьера в карточке заказа'
          enable: '<br>В карточке заказа на вкладках сейчас\\позже будет отображен выбранный курьер'

  sm_chosen:
    nothing_found: 'ничего не найдено'
    buttons:
      add_button: 'Добавить'
    placeholders:
      search: 'поиск'

  date_range_report:
    from: 'от'
    to: 'до'

  day_editor:
    to: 'до'
    add: 'Добавить'
    time_hint: 'Для добавления периода необходимо скорректировать предыдущий период, он не должен оканчиваться на 23:59'
    not_working: 'Не работаем'

  sm_delivery_map:
    buttons:
      finish: 'Закончить'
      cancel: 'Отменить'

  sm_button:
    back: 'Назад'
    save: 'Сохранить'
    cancel: 'Отменить'
    delete: 'Удалить'
    upload: 'Загрузить'
    change: 'Изменить'

  sm_notification_limiter:
    text: 'И еще {{noticifationPending}} уведомлений'
    hide_all: 'скрыть все уведомления'

  tariff:
    price_text: '{{tarrifPrice}} р/мес'
    buttons:
      select_tariff: 'Выбрать'
    full_tariffs: 'Полная версия тарифов и их сравнение на <a href="https://smartomato.ru/pricing" target="_blank">сайте Смартомато</a>.'

  available:
    available: 'Доступно'
    not_available: 'На стопе'
    call: 'Уточнить наличие по телефону'

  validation:
    phone: 'Телефон должен содержать только цифры и +'
    login: 'Некорректный адрес электронной почты'
    required_field: 'Обязательное поле'

  errors:
    status: 'Статус не может быть установлен.'
    code:
      403: 'Недостаточно прав для выполнения данного действия'
